<template>
  <div class="record-page">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <el-button type="text" @click="goBack" class="back-button">
          <i class="el-icon-arrow-left"></i>
          返回列表
        </el-button>
        <h2 class="page-title">录入原始记录</h2>
      </div>
      <div class="header-right">
        <el-button type="primary" @click="handleSubmit('0')" :loading="loading" :disabled="referenceFilling || loading">保存</el-button>
        <el-button type="primary" @click="handleSubmit('3')" :loading="loading" :disabled="referenceFilling || loading">完成</el-button>
        <el-button type="warning" @click="reference" :disabled="referenceFilling || loading">参照</el-button>
        <el-button type="primary" @click="handlePDF">查看原始记录</el-button>
        <el-button @click="goBack">取 消</el-button>
      </div>
    </div>

    <!-- 页面加载遮罩层（初始加载 / 参照回填） -->
    <div v-loading="pageLoading || referenceFilling" :element-loading-text="referenceFilling ? '正在回填参照数据，请稍候...' : '正在加载原始记录数据...'" element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)" class="loading-overlay" v-if="pageLoading || referenceFilling"></div>

    <!-- 主要内容区域 -->
    <div class="page-content">
      <!-- 封面页 -->
      <el-card class="page-card" shadow="hover">
        <div slot="header" class="card-header">
          <span>封面</span>
        </div>
        <div class="card-content">
          <div class="cover-content">
            <!-- 记录编号和二维码 -->
            <div class="cover-top-row">
              <div class="cover-record-number">
                <span class="cover-label">记录编号：</span>
                <el-input v-model="coverInfo.recordNum" placeholder="请输入记录编号" class="cover-input" size="medium"></el-input>
              </div>
              <div class="cover-qrcode-section">
                <div class="cover-qrcode-upload">
                  <span class="cover-label">二维码：</span>
                  <div class="qrcode-upload-area">
                    <!-- 上传功能已注释，仅作显示用途 -->
                    <!-- <el-upload class="qrcode-uploader" action="#" :show-file-list="false" :before-upload="beforeQrcodeUpload" :http-request="handleQrcodeUpload" accept="image/*">
                      <div v-if="coverInfo.qrcodeImage" class="qrcode-preview">
                        <img :src="coverInfo.qrcodeImage" class="qrcode-image" alt="二维码">
                        <div class="elcode-overlay">
                          <i class="el-icon-edit-outline"></i>
                          <span>重新上传</span>
                        </div>
                      </div>
                      <div v-else class="qrcode-upload-placeholder">
                        <i classss="qrcod-plus qrcode-uploader-icon"></i>
                        <div class="qrcode-uploader-text">上传二维码</div>
                      </div>
                    </el-upload> -->
                    <!-- 仅显示二维码图片 -->
                    <div class="qrcode-display">
                      <img v-if="coverInfo.qrcodeImage" :src="coverInfo.qrcodeImage" class="qrcode-image" alt="二维码">
                      <div v-else class="qrcode-empty-placeholder">
                        <!-- 空白占位框 -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 空白区域 -->
            <div class="cover-spacer"></div>

            <!-- 主标题 -->
            <div class="cover-title-section">
              <!-- <h1 v-if="this.recordInfo.equipmentName == '自动扶梯原始记录'" class="cover-main-title">自动扶梯</h1>
              <h1 v-else class="cover-main-title">自动人行道</h1> -->
              <h1 class="cover-main-title">{{coverInfo.EQP_VART_NAME}}</h1>
              <h2 class="cover-sub-title">自行检测原始记录</h2>
            </div>

            <!-- 空白区域 -->
            <div class="cover-spacer-large"></div>

            <!-- 基本信息表格 -->
            <div class="cover-info-section">
              <div class="cover-info-row">
                <span class="cover-info-label">使用单位：</span>
                <span class="cover-info-value">{{coverInfo.useUnitName}}</span>
                <!-- <el-input v-model="coverInfo.useUnitName" placeholder="请输入使用单位" class="cover-info-input" size="medium"></el-input> -->
              </div>
              <div class="cover-info-row">
                <span class="cover-info-label">设备代码：</span>
                <!-- <el-input v-model="coverInfo.EQP_STATION_COD" placeholder="请输入设备代码" class="cover-info-input" size="medium"></el-input> -->
                <span class="cover-info-value">{{coverInfo.EQP_STATION_COD}}</span>
              </div>
              <div class="cover-info-row">
                <span class="cover-info-label">设备类别：</span>
                <!-- <span v-if="this.recordInfo.equipmentName == '自动扶梯原始记录'" class="cover-info-value">自动扶梯</span>
                <span v-else class="cover-info-value">自动人行道</span> -->
                <span class="cover-info-value">{{coverInfo.EQP_SORT_NAME}}</span>
              </div>
              <div class="cover-info-row">
                <span class="cover-info-label">检测日期：</span>
                <!-- <el-date-picker v-model="coverInfo.testDate" type="date" placeholder="请选择检测日期" class="cover-info-input" size="medium" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker> -->
                <span class="cover-info-value">{{coverInfo.testDate}}</span>
              </div>
            </div>

            <!-- 空白区域 -->
            <div class="cover-spacer-large"></div>

            <!-- 底部公司信息 -->
            <div class="cover-company">
              <p class="cover-company-name">晨宇安全科技集团有限公司 编</p>
            </div>
          </div>
        </div>
      </el-card>

      <!-- 第一页卡片 -->
      <el-card class="page-card" shadow="hover">
        <div slot="header" class="card-header">
          <span>填写说明</span>
          <div class="card-header-qrcode">
            <img v-if="coverInfo.qrcodeImage" :src="coverInfo.qrcodeImage" alt="二维码" class="header-qrcode-image">
          </div>
        </div>
        <div class="card-content">
          <div class="instructions-content">
            <h3 class="instructions-title">填写说明</h3>
            <div class="instructions-list">
              <div class="instruction-item">
                <span class="instruction-number">一、</span>
                <span class="instruction-text">本原始记录适用于曳引驱动杂物电梯(含防爆)的检测。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">二、</span>
                <span class="instruction-text">本原始记录的检测基本内容、要求和方法等均依据《电梯自行检测规则》(TSG T7008-2023)制定。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">三、</span>
                <span class="instruction-text">检测项目分为关键检测项目和一般检测项目两个类别，其中标有"*"的为关键检测项目。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">四、</span>
                <span class="instruction-text">检测所用仪器、设备应完好且在计量检定/校准有效期内。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">五、</span>
                <span class="instruction-text">检测过程中，检测人员应当使用检测信息化管理系统，按照要求如实、规范地记录检测情况，不得漏检、漏记。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">六、</span>
                <span class="instruction-text">原始记录中，检测项目的"检测结果"应当按照如下要求进行填写：<br />
                  1、对于要求测试数据的项目，在"检测结果"栏填写实测数据；<br />
                  2、对于未要求测试数据的项目，如果经检测符合要求，在"检测结果"栏填写"符合"；如果经检测不符合要求，在"检测结果"栏填写"不符合"，并在"检测问题汇总"栏填写具体的不符合情形描述；<br />
                  3、对于受检电梯不适用的项目，在"检测结果"栏填写"无此项"。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">七、</span>
                <span class="instruction-text">原始记录一律使用移动终端或电脑终端填写，手写填写或修改无效；</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">八、</span>
                <span class="instruction-text">原始记录应当有检测人员、校核人员签字及检测日期，并对检测结果的真实性、准确性、可靠性、正确性、公正性负责；</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">九、</span>
                <span
                      class="instruction-text">现场全部检测项目经检测后，检测人员应当向使用单位出具与检测记录内容一致的《电梯自行检测备忘录》，使用单位对《电梯自行检测备忘录》上所列出的检测结果为不符合的检测项目及时整改，整改后检测人员对整改进行确认，整改确认情况应记入原始记录中，《电梯自行检测备忘录》及《电梯检测报告》与本原始记录一并存档；</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">十、</span>
                <span class="instruction-text">检测工作必须在满足检测环境条件的前提下进行。检测人员确认现场满足检测条件后方可实施现场检测；</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">十一、</span>
                <span class="instruction-text">本原始记录是对设备进行检测当时现场情况的如实记录，仅对当时现场设备状况负责。</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>

      <!-- 设备信息卡片 -->
      <el-card class="page-card" shadow="hover">
        <div slot="header" class="card-header">
          <span>设备信息</span>
          <div class="card-header-qrcode">
            <img v-if="coverInfo.qrcodeImage" :src="coverInfo.qrcodeImage" alt="二维码" class="header-qrcode-image">
          </div>
        </div>
        <div class="card-content">
          <div class="equipment-info-content">
            <!-- 基本设备信息表格 -->
            <div class="equipment-basic-info">
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">使用单位名称</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.useUnitName" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">单位内编号</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.unitInternalNumber" size="small" readonly></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">统一信用代码</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.USE_UNT_COD" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">设备品种</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.equipmentType" size="small" readonly></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">设备安装地点</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.installLocation" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">产品型号</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.productModel" size="small" readonly></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">使用登记证号</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.registrationNumber" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">产品编号</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.productNumber" size="small" readonly></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">制造单位名称</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.manufacturerName" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">制造日期</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-date-picker v-model="equipmentInfo.manufactureDate" type="date" size="small" style="width: 100%" format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled></el-date-picker>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">改造单位名称</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.renovationUnitName" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">改造日期</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-date-picker v-model="equipmentInfo.renovationDate" type="date" size="small" style="width: 100%" format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled></el-date-picker>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">维护保养单位</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.maintenanceUnit" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">安管人员</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.safetyManager" size="small" readonly></el-input>
                </el-col>
              </el-row>
            </div>

            <!-- 设备技术参数 -->
            <div class="equipment-params">
              <div class="equipment-params-header">
                <div class="params-title-wrapper">
                  <div class="params-title-text">设备技术参数</div>
                </div>
                <div class="params-qrcode">
                  <img v-if="coverInfo.qrcodeImage" :src="coverInfo.qrcodeImage" alt="二维码" class="params-qrcode-image">
                </div>
              </div>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="3" class="info-label-col-vertical" style="visibility: hidden;">占位</el-col>
                <el-col :span="5" class="info-label-col">额定载重量(kg)</el-col>
                <el-col :span="4" class="info-input-col">
                  <el-input v-model="equipmentInfo.ratedLoad" size="small" readonly></el-input>
                </el-col>
                <el-col :span="4" class="info-label-col">层/站/门</el-col>
                <el-col :span="8" class="info-input-col">
                  <el-input v-model="equipmentInfo.floorStationDoor" size="small" readonly></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="3" class="info-label-col-empty"></el-col>
                <el-col :span="5" class="info-label-col">额定速度(m/s)</el-col>
                <el-col :span="4" class="info-input-col">
                  <el-input v-model="equipmentInfo.ratedSpeed" size="small" readonly></el-input>
                </el-col>
                <el-col :span="4" class="info-label-col">控制方式</el-col>
                <el-col :span="8" class="info-input-col">
                  <el-input v-model="equipmentInfo.controlMethod" size="small" readonly></el-input>
                </el-col>
              </el-row>
            </div>

            <!-- 主要检测仪器设备一览表 -->
            <div class="instrument-table-section">
              <div class="section-title-row">
                <div class="section-title">主要检测仪器设备一览表</div>
                <div class="toolbox-selector">
                  <el-button type="default" size="small" style="margin-right: 10px;" :loading="toolboxRestoreLoading" @click="handleRestoreDefaultToolbox">默认配置</el-button>
                  <span style="margin-right: 10px;">工具箱选择：</span>
                  <el-input v-model="selectedToolboxNum" size="small" readonly style="width: 200px;"></el-input>
                </div>
              </div>
              <el-table :data="instrumentTableData" border size="mini" :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" row-key="id" style="width: 100%">
                <el-table-column label="操作" width="90" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" icon="el-icon-delete" @click="handleInstrumentDelete(scope.row, 'left')">删除</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="serialNumber" label="序号" min-width="60" align="center"></el-table-column>
                <el-table-column prop="name" label="名称" min-width="150" align="center">
                  <template slot-scope="scope">
                    <el-input :value="getEquipmentNameById(scope.row.name)" size="mini" readonly></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="managementNumber" label="管理编号" min-width="120" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.managementNumber" size="mini" readonly></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="usageRecord" label="使用记录" min-width="100" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.usageRecord" size="mini" readonly></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="90" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" icon="el-icon-delete" @click="handleInstrumentDelete(scope.row, 'right')">删除</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="serialNumber2" label="序号" min-width="60" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.serialNumber2">{{ scope.row.serialNumber2 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name2" label="名称" min-width="150" align="center">
                  <template slot-scope="scope">
                    <el-input :value="getEquipmentNameById(scope.row.name2)" size="mini" readonly v-if="scope.row.serialNumber2"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="managementNumber2" label="管理编号" min-width="120" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.managementNumber2" size="mini" v-if="scope.row.serialNumber2" readonly></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="usageRecord2" label="使用记录" min-width="100" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.usageRecord2" size="mini" v-if="scope.row.serialNumber2" readonly></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 检测依据 -->
            <div class="detection-basis">
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="3" class="info-label-col">检测依据</el-col>
                <el-col :span="21" class="info-input-col">
                  <el-input v-model="equipmentInfo.standardData" type="textarea" :rows="3" size="small"></el-input>
                </el-col>
              </el-row>
            </div>

            <!-- 检测环境条件确认 -->
            <div class="environment-conditions-section">
              <div class="section-title">检测环境条件确认</div>
              <el-row :gutter="0" class="info-table-row" style="margin-bottom: 10px;">
                <el-col :span="4" class="info-label-col">供电电压(V)</el-col>
                <el-col :span="4" class="info-input-col">
                  <el-input v-model="equipmentInfo.powerSupply" size="small"></el-input>
                </el-col>
                <el-col :span="4" class="info-label-col">温度(℃)</el-col>
                <el-col :span="4" class="info-input-col">
                  <el-input v-model="equipmentInfo.temperature" size="small"></el-input>
                </el-col>
                <el-col :span="4" class="info-label-col">湿度(%)</el-col>
                <el-col :span="4" class="info-input-col">
                  <el-input v-model="equipmentInfo.humidity" size="small"></el-input>
                </el-col>
              </el-row>
              <el-table :data="environmentConditionsData" border size="mini" :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="environmentConditionsSpanMethod"
                        row-key="id" style="width: 100%">
                <el-table-column prop="serialNumber" label="序号" min-width="60" align="center"></el-table-column>
                <el-table-column prop="requirement" label="检测环境条件要求" align="left" min-width="500"></el-table-column>
                <el-table-column prop="confirmResult" label="确认结果" min-width="120" align="center">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.confirmResult" placeholder="请选择" size="mini" style="width: 100%">
                      <el-option label="是" value="qualified"></el-option>
                      <el-option label="否" value="unqualified"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 检测问题汇总和备注 -->
            <div class="summary-section">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="summary-item">
                    <div class="summary-label">检测问题汇总</div>
                    <el-input v-model="equipmentInfo.problemSummary" type="textarea" :rows="4" placeholder="无" size="small"></el-input>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="summary-item">
                    <div class="summary-label">备注</div>
                    <el-input v-model="equipmentInfo.remarks" type="textarea" :rows="4" size="small"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- 日期和签名 -->
            <div class="signature-section">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="signature-item">
                    <span class="signature-label">下次检测日期：</span>
                    <span>{{ equipmentInfo.nextTestDate || '无' }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="signature-item">
                    <span class="signature-label">下次检验日期：</span>
                    <span>{{ equipmentInfo.nextCheckDate || '无' }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top: 20px;">
                <el-col :span="12">
                  <div class="signature-item">
                    <span class="signature-label">检测人员：</span>
                    <div class="personnel-select-area">
                      <el-select v-model="equipmentInfo.detectionPersonnel" placeholder="请选择检测人员" style="width: 100%">
                        <el-option v-for="item in detectionPersonnelOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="signature-item">
                    <span class="signature-label">校核人员：</span>
                    <div class="personnel-select-area">
                      <el-select v-model="equipmentInfo.reviewPersonnel" placeholder="请选择校核人员" style="width: 100%">
                        <el-option v-for="item in reviewPersonnelOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin-top: 20px;">
                <el-col :span="24">
                  <div class="signature-item" style="text-align: right;">
                    <span class="signature-label">检测日期：</span>
                    <el-date-picker v-model="equipmentInfo.detectionDate" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-card>

      <!-- 第一页卡片 - 检测项目编号及名称 -->
      <el-card class="page-card" shadow="hover">
        <div slot="header" class="card-header">
          <span>检测项目编号及名称</span>
          <!-- <el-button type="primary" size="small" @click="testSaveData" style="float: right;">测试保存数据</el-button> -->
        </div>
        <div class="card-content" style="height: 700px;">
          <!-- 左右两栏布局 -->
          <div class="page-one-layout">
            <!-- 左侧导航区域 -->
            <div class="navigation-panel">
              <div class="nav-title">快速导航</div>
              <div class="nav-list">
                <div v-for="navItem in navigationList" :key="navItem.id" class="nav-item" :class="{ 'active': activeNavId === navItem.id, 'nav-item-level-2': navItem.level === 2 }"
                     @click="scrollToItem(navItem.id)">
                  <span class="nav-number">{{ navItem.itemNumber }}</span>
                  <span class="nav-description">{{ navItem.description }}</span>
                </div>
              </div>
            </div>

            <!-- 右侧表格区域 -->
            <div class="table-panel">
              <el-table ref="pageOneTable" :data="pageOneData" border style="width: 100%; height: 100%;" :header-cell-style="{ background: '#f5f7fa', textAlign: 'left' }"
                        :cell-style="pageOneTableCellStyle" :span-method="pageOneTableSpanMethod" row-key="id" :row-class-name="getRowClassName" :height="700">
                <el-table-column prop="itemNumber" label="检测项目编号及名称" align="left" min-width="400">
                  <template slot-scope="scope">
                    <!-- 默认行布局 -->
                    <div v-if="scope.row.itemNumber !== 'A2.3.3.1.1'" class="item-content" :class="'level-' + scope.row.level">
                      <span v-if="scope.row.itemNumber" class="item-number" :class="'level-' + scope.row.level + '-number'">
                        {{ scope.row.itemNumber }}
                      </span>
                      <span class="item-description" :class="'level-' + scope.row.level + '-desc'" v-html="scope.row.description"></span>
                    </div>
                    <!-- A2.3.3.1.1 特殊布局：左侧编号，右侧文本+图片（上下） -->
                    <div v-else class="item-content item-content-a13141" :class="'level-' + scope.row.level">
                      <span class="item-number" :class="'level-' + scope.row.level + '-number'">
                        {{ scope.row.itemNumber }}
                      </span>
                      <div class="item-a13141-right">
                        <div class="item-description" :class="'level-' + scope.row.level + '-desc'" v-html="scope.row.description"></div>
                        <div class="item-image-wrapper">
                          <img :src="require('@/assets/images/A2.3.3.png')" alt="检测示意图" class="item-image" />
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="result" label="检验结果" :width="resultColumnWidth || 240" align="center">
                  <template slot-scope="scope">
                    <!-- Level 3 项目：左(颜色按钮) + 右(已勾选详情文本) -->
                    <div v-if="scope.row.level === 3" class="result-cell">
                      <div class="result-cell-left">
                        <div class="result-color-block" :class="getResultColorClass(scope.row)" @click="openResultDialog(scope.row)" :title="getResultTitle(scope.row)">
                          <div class="result-content">
                            <div class="result-text">{{ getResultText(scope.row.result) }}</div>
                            <div v-if="scope.row.attachmentTable" class="attachment-info">
                              *详情见：{{ getAttachmentInfoText(scope.row.attachmentTable) }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="result-cell-right">
                        <div v-for="(txt, idx) in getRowSelectedDetailTexts(scope.row)" :key="`${scope.row.id || scope.row.itemNumber}-detail-${idx}`" class="result-detail-line">
                          {{ txt }}
                        </div>
                      </div>
                    </div>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <!-- 新增综合检验结果列 -->
                <!-- <el-table-column prop="autoResult" label="综合检验结果" width="120" align="center">
                  <template slot-scope="scope">                    
                    <div v-if="scope.row.hasChildren && (scope.row.level === 1 || scope.row.level === 2) && scope.row.autoResult" class="result-color-block"
                         :class="getAutoResultColorClass(scope.row.autoResult)" style="cursor: default;">
                      <span class="result-text">{{ getResultText(scope.row.autoResult) }}</span>
                    </div>
                    <span v-else>-</span>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
          </div>
        </div>
      </el-card>

      <!-- 第二页卡片 - 已隐藏，现在附表通过弹窗显示 -->
      <el-card v-if="false" class="page-card" shadow="hover">
        <div slot="header" class="card-header">
          <span></span>
        </div>
        <div class="card-content page-two-content">
          <!-- 附表 A1.2.7.1(1)：层门间隙检测记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.2.7.1(1)：层门间隙检测记录表(每格左上方填写层站，右下方填写检测结果，单位为 mm)</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable1Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge" size="mini">
                <!-- 第一列：项目名称 -->
                <el-table-column label="检测层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <!-- 13列数据列 -->
                <el-table-column v-for="(col, index) in pageTwoTable1.columns" :key="col.id || `table1-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="200">
                  <template slot-scope="scope">
                    <!-- 第一行：抽查层站输入框（会被合并） -->
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable1.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <!-- 第二行：层站/检测结果标题 -->
                    <div v-else-if="scope.$index === 1" class="header-cell">层站/检测结果</div>
                    <!-- 第3-6行：分割单元格 -->
                    <div v-else-if="scope.$index > 1" class="split-cell">
                      <div class="cell-top-left">
                        <el-input v-model="col.data[scope.row.key].floor" placeholder="层站" size="small"></el-input>
                      </div>
                      <div class="cell-bottom-right">
                        <el-input v-model="col.data[scope.row.key].result" placeholder="结果" size="small"></el-input>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 检验结果编辑弹窗 -->
    <el-dialog title="编辑检验结果" :visible.sync="resultDialogVisible" width="600px" :close-on-click-modal="false" :before-close="onResultDialogClose">
      <div v-if="currentEditRow" class="result-dialog-content">
        <div class="result-item-info">
          <div class="info-label">检测项目：</div>
          <div class="info-value">{{ currentEditRow.itemNumber }} {{ currentEditRow.description }}</div>
        </div>

        <div class="result-selection">
          <div class="selection-label">检验结果：</div>
          <el-radio-group v-model="tempResult" size="medium" @change="handleResultChange">
            <el-radio label="qualified" border>符合</el-radio>
            <el-radio label="unqualified" border>不符合</el-radio>
            <el-radio label="notApplicable" border>无此项</el-radio>
          </el-radio-group>
        </div>

        <!-- 详情列表 -->
        <div v-if="detailList.length > 0" class="detail-list-section" style="margin-top: 20px; max-height: 300px; overflow-y: auto;">
          <div class="detail-list-label" style="margin-bottom: 10px; font-weight: bold;">详情列表：</div>
          <div v-for="item in detailList" :key="item.contentDetailPid" class="detail-item" @click="toggleDetailSelection(item)"
               style="display: flex; align-items: center; margin-bottom: 10px; padding: 8px; border: 1px solid #e4e7ed; border-radius: 4px;">
            <el-checkbox v-model="selectedDetailPids" :label="item.contentDetailPid" @click.native.stop></el-checkbox>
            <div style="flex: 1;">
              <template v-if="item.detailContent && hasDetailPlaceholders(item.detailContent)">
                <span v-for="(seg, segIndex) in getDetailContentSegments(item)" :key="`${item.contentDetailPid}-${segIndex}`">
                  <span v-if="seg.type === 'text'">{{ seg.value }}</span>
                  <el-input v-else v-model="detailInputValues[item.contentDetailPid][seg.inputIndex]" size="small" style="width: 120px; display: inline-block; margin: 0 5px;" placeholder="请输入"
                            @click.native.stop></el-input>
                </span>
              </template>
              <span v-else>{{ item.detailContent }}</span>
            </div>
          </div>
        </div>

        <div v-if="detailListLoading" style="text-align: center; padding: 20px;">
          <i class="el-icon-loading"></i> 加载中...
        </div>

        <div v-if="currentEditRow.attachmentTable" class="attachment-section" style="margin-top: 20px;">
          <div class="attachment-label">{{ getAttachmentTitle(currentEditRow.attachmentTable) }}</div>
          <el-button type="primary" size="small" @click="openAttachmentDialog(currentEditRow.attachmentTable)">
            <i class="el-icon-document"></i> 打开附表
          </el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onResultDialogClose()">取 消</el-button>
        <el-button type="primary" @click="saveResult(tempResult)">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 附表查看弹窗 -->
    <el-dialog :title="getAttachmentTitle()" :visible.sync="attachmentDialogVisible" width="95%" top="5vh" :close-on-click-modal="false" :before-close="handleAttachmentDialogClose">
      <div class="attachment-dialog-content">
        <div v-if="currentAttachmentTableConfig" class="table-section">
          <div class="table-title">{{ getAttachmentTitle() }}</div>
          <div class="table-scroll-wrapper">
            <el-table :data="currentAttachmentTableConfig.rows" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" size="mini" style="width: 100%">
              <el-table-column label="项目" prop="label" width="280" fixed align="left"></el-table-column>
              <el-table-column v-for="colIndex in attachmentColumnIndexes" :key="`${currentAttachmentTable}-col-${colIndex}`" :label="String(colIndex + 1)" align="center" min-width="88">
                <template slot-scope="scope">
                  <el-input :value="getGoodsElevatorCellValue(colIndex, scope.row.key)" placeholder="请输入" size="mini" @input="setGoodsElevatorCellValue(colIndex, scope.row.key, $event)"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else class="no-attachment">
          <p>附表内容正在加载...</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleAttachmentDialogClose()">关 闭</el-button>
        <el-button type="primary" @click="handleAttachmentDialogSave">保 存</el-button>
      </div>
    </el-dialog>

    <!-- PDF预览弹窗 -->
    <el-dialog title="PDF预览" :visible.sync="pdfPreviewVisible" width="90%" :close-on-click-modal="false">
      <PdfImgViewer v-if="pdfPreviewVisible && pdfFileName" :fileName="pdfFileName" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="pdfPreviewVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 参照弹窗 -->
    <reference-dialog :visible.sync="referenceDialogVisible" :default-use-unt-name="equipmentInfo.useUnitName" :default-eqp-name="equipmentInfo.eqpTempName"
                      @referenceConfirm="handleReferenceConfirm" />
  </div>
</template>

<script>
import { saveTestData, queryEmployeeDropdown, queryTestDataInfo, queryEqptList, queryToolboxEqptInfos, queryDetailListByContentCode, queryTestDataTest, previewTestDataPdf } from '@/api/contract/contract';
import { pageOneTreeData as pageOneTreeDataDefault } from './pageOneTreeData3';
import {
  createGapTable,
  createAutoCloseTable,
  createEmergencyUnlockTable,
  createDoorLockTable,
  createLockVerifyTable,
  createStationSignTable,
  createRunTestTable,
  GOODS_ELEVATOR_ATTACHMENT_TITLES,
  GOODS_ELEVATOR_FLOOR_APPENDIX_MAP,
  serializeGoodsElevatorTable,
  resolveGoodsElevatorTableCell,
  isGoodsElevatorPageTwoDataKey
} from './goodsElevatorTableConfig';
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue';

function createDefaultPageOneTreeData () {
  return JSON.parse(JSON.stringify(pageOneTreeDataDefault || []));
}

function createDefaultGoodsElevatorTables () {
  return {
    table1: createGapTable(),
    table2: createAutoCloseTable(),
    table3: createEmergencyUnlockTable(),
    table4: createDoorLockTable(),
    table5: createLockVerifyTable(),
    table6: createStationSignTable(),
    table7: createRunTestTable()
  };
}

import ReferenceDialog from './reference.vue';

export default {
  components: {
    ReferenceDialog,
    PdfImgViewer
  },
  name: 'RecordPage3',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    const today = new Date();
    const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    return {
      additionalDataList: {},
      loading: false,
      pageLoading: false, // 页面加载状态
      referenceFilling: false, // 参照数据回填中（阻塞页面操作）
      // PDF预览相关
      pdfPreviewVisible: false, // PDF预览弹窗显示状态
      pdfFileName: '', // PDF文件名
      recordInfo: {},
      // 封面信息
      coverInfo: {
        EQP_VART_NAME: '', // 原始记录名称 - «EQP_VART_NAME»
        EQP_SORT_NAME: '', // 设备类别 - «EQP_SORT_NAME»
        recordNum: '', // 记录编号 - «recordNum»
        useUnitName: '', // 使用单位 - «USE_UNT_NAME»
        EQP_STATION_COD: '', // 设备代码 - «EQP_STATION_COD»
        testDate: todayString, // 检测日期 - «testDate»
        qrcodeImage: '', // 二维码图片预览 - «IMG_recordNumQrcode»
        qrcodeBase64: '' // 二维码图片base64数据
      },
      // 设备信息
      equipmentInfo: {
        useUnitName: '', // 使用单位名称 - «USE_UNT_NAME»
        unitInternalNumber: '', // 单位内编号 - «EQP_INNER_COD»
        USE_UNT_COD: '', // 统一信用代码 - «USE_UNT_COD»
        equipmentType: '', // 设备品种 - «EQP_VART_NAME»
        installLocation: '', // 设备安装地点 - «EQP_AREA_NAME»
        productModel: '', // 产品型号 - «EQP_MOD»
        registrationNumber: '', // 使用登记证号 - «EQP_USECERT_COD»
        productNumber: '', // 产品编号 - «FACTORY_COD»
        powerSupply: '', // 供电电压(V)
        humidity: '', // 湿度
        temperature: '', // 温度
        manufacturerName: '', // 制造单位名称 - «MAKE_UNT_NAME»
        manufactureDate: '', // 制造日期 - «MAKE_DATE»
        renovationUnitName: '', // 改造单位名称 - «renovation_unt_name»
        renovationDate: '', // 改造日期 - «renovation_date»
        maintenanceUnit: '', // 维护保养单位 - «service_unt_name»
        safetyManager: '', // 安管人员 - «SAFE_MEN»
        ratedLoad: '', // 额定载重量 - «RATEDLOAD»
        controlMethod: '', // 控制方式 - «CONTROL_TYPE»
        ratedSpeed: '', // 额定速度 - «RATEDVELOCITY»
        floorStationDoor: '', // 层/站/门 - «FLOOR_STADE_DOOR»
        nominalSpeed: '', // 名义速度 - «RUNVELOCITY» / 名义速度展示
        inclinationAngle: '', // 倾斜角 - «DIP_ANGLE»
        nominalWidth: '', // 名义宽度 - «NOMI_WIDTH»
        transportCapacity: '', // 输送能力 - «TRANSPORT_CAPACITY»
        sectionLength: '', // 使用区段长度 - «SLIDWAY_USE_LENG»
        liftHeight: '', // 提升高度 - «ELEHEIGHT»
        // 与接口 additionalData 根字段对应，便于回填后提交
        equipmentName: '', // «EQP_NAME»
        eqpSortName: '', // «EQP_SORT_NAME»（与封面 coverInfo.EQP_SORT_NAME 同步）
        oidNo: '', // «OIDNO»
        eqpTempName: '', // «EQP_TEMP_NAME»
        eqpUseAddr: '', // «EQP_USE_ADDR»
        eleFloorNumber: null, // «ELEFLOORNUMBER»
        eleStadeNumber: null, // «ELESTADENUMBER»
        eleDoorNumber: null, // «ELEDOORNUMBER»
        firstYear: '', // «FIRST_YEAR»
        eqpRegCod: null, // «EQP_REG_COD»
        standardData: '', // 检测依据
        problemSummary: '无', // 检测问题汇总 - «reportConclusion»
        remarks: '', // 备注 - «reportConclusionDesc»
        nextTestDate: '', // 下次检测日期 - «nextTestDate» (用于提交)
        nextCheckDate: '', // 下次检验日期 - «nextCheckDate» (用于提交)
        nextTestYear: '', // 下次检测年份（历史字段，兼容保留）
        nextTestMonth: '', // 下次检测月份（历史字段，兼容保留）
        nextCheckYear: '', // 下次检验年份（历史字段，兼容保留）
        nextCheckMonth: '', // 下次检验月份（历史字段，兼容保留）
        detectionPersonnel: '', // 检测人员图片预览
        detectionPersonnelBase64: '', // 检测人员图片base64 - «IMG_test»
        reviewPersonnel: '', // 校核人员图片预览
        reviewPersonnelBase64: '', // 校核人员图片base64 - «IMG_audit»
        detectionDate: '' // 检测日期 - «testEmployeeDate»
      },
      // 人员选项数据
      detectionPersonnelOptions: [], // 检测人员选项
      reviewPersonnelOptions: [], // 校核人员选项
      // 设备选项数据
      equipmentOptions: [], // 设备选项列表
      selectedEquipmentIds: [], // 已选择的设备ID列表，用于过滤
      // 工具箱相关数据
      selectedToolboxNum: '', // 工具箱号（仅展示）
      toolboxRestoreLoading: false, // 恢复默认工具箱 API 请求中
      // 检测仪器设备表格数据 - 对应 «EquipmentName01-20» 和 «MgmtNo01-20»
      instrumentTableData: [
        { id: 'instrument-1', serialNumber: 1, name: '', managementNumber: '', usageRecord: '', serialNumber2: 11, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName01», «MgmtNo01»
        { id: 'instrument-2', serialNumber: 2, name: '', managementNumber: '', usageRecord: '', serialNumber2: 12, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName02», «MgmtNo02»
        { id: 'instrument-3', serialNumber: 3, name: '', managementNumber: '', usageRecord: '', serialNumber2: 13, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName03», «MgmtNo03»
        { id: 'instrument-4', serialNumber: 4, name: '', managementNumber: '', usageRecord: '', serialNumber2: 14, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName04», «MgmtNo04»
        { id: 'instrument-5', serialNumber: 5, name: '', managementNumber: '', usageRecord: '', serialNumber2: 15, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName05», «MgmtNo05»
        { id: 'instrument-6', serialNumber: 6, name: '', managementNumber: '', usageRecord: '', serialNumber2: 16, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName06», «MgmtNo06»
        { id: 'instrument-7', serialNumber: 7, name: '', managementNumber: '', usageRecord: '', serialNumber2: 17, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName07», «MgmtNo07»
        { id: 'instrument-8', serialNumber: 8, name: '', managementNumber: '', usageRecord: '', serialNumber2: 18, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName08», «MgmtNo08»
        { id: 'instrument-9', serialNumber: 9, name: '', managementNumber: '', usageRecord: '', serialNumber2: 19, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName09», «MgmtNo09»
        { id: 'instrument-10', serialNumber: 10, name: '', managementNumber: '', usageRecord: '', serialNumber2: 20, name2: '', managementNumber2: '', usageRecord2: '' } // «EquipmentName10», «MgmtNo10»
      ],
      // 检测环境条件数据
      environmentConditionsData: [
        { id: 'env-1', serialNumber: 1, requirement: '机房或者机器设备间的空气温度保持在 5～40℃之间；', confirmResult: 'qualified' },
        { id: 'env-2', serialNumber: 2, requirement: '电网输入正常，电压波动在额定电压值±7％的范围内；', confirmResult: 'qualified' },
        { id: 'env-3', serialNumber: 3, requirement: '环境空气中没有腐蚀性和易燃性气体及导电尘埃；', confirmResult: 'qualified' },
        { id: 'env-4', serialNumber: 4, requirement: '检测现场(主要指机房或者机器设备间、井道、轿顶、底坑)清洁，没有与电梯运行无关的物品和设备，基站、相关层站等非检测人员可能进入的区域进行了必要的封闭和防护，且放置了表明正在进行检测的警示标志；', confirmResult: 'qualified' },
        { id: 'env-5', serialNumber: 5, requirement: '特殊情况下，电梯设计文件对温度、湿度、电压、环境空气条件等进行了专门规定的，检测现场的温度、湿度、电压、环境空气条件等符合电梯设计文件的规定；', confirmResult: 'qualified' },
        { id: 'env-6', serialNumber: 6, requirement: '现场检测条件不能持续满足以上 1~5 条的要求', confirmResult: 'unqualified' },
        { id: 'env-7', serialNumber: 7, requirement: '继续实施检测可能造成危险', confirmResult: 'unqualified' },
        { id: 'env-8', serialNumber: 8, requirement: '进行整机检测时，电梯不能正常运行', confirmResult: 'unqualified' }
      ],
      pageOneTreeData: createDefaultPageOneTreeData(),
      pageOneData: [],
      // 导航相关数据
      navigationList: [], // 导航列表（两级结构）
      activeNavId: '', // 当前激活的导航项ID
      // 检验结果编辑弹窗
      resultDialogVisible: false, // 检验结果编辑弹窗显示状态
      currentEditRow: null, // 当前编辑的行数据
      tempResult: null, // 弹窗内的临时检验结果，未点击“确定”不落库
      initialEditRowResult: null, // 打开弹窗时的原始结果，用于取消/关闭时回滚
      initialDialogSelectedDetailPids: [], // 打开弹窗时的详情选中快照（用于关闭回滚）
      initialDialogDetailInputValues: {}, // 打开弹窗时的详情输入值快照（用于关闭回滚）
      detailList: [], // 检验结果详情列表
      selectedDetailPids: [], // 选中的详情PID列表
      detailInputValues: {}, // 详情输入框的值（用于处理"其他:${var1}"类型）
      detailListLoading: false, // 详情列表加载状态
      initialSelectedDetailPids: {}, // 记录页面加载时每个检验项已保存的详情PID列表（初始状态），用于判断新勾选的项
      unqualifiedCustomInfoList: [], // “不符合且未勾选详情”时，提交到 infoList 的自定义记录
      resultColumnWidth: 0, // 检验结果列宽（按表格宽度的 35% 动态计算）
      // 附表查看弹窗
      attachmentDialogVisible: false, // 附表查看弹窗显示状态
      currentAttachmentTable: '', // 当前查看的附表ID
      attachmentDialogBackup: null, // 附表弹窗打开时快照（用于关闭不保存时回滚）
      // 参照弹窗
      referenceDialogVisible: false,
      goodsElevatorTables: createDefaultGoodsElevatorTables()
    };
  },
  computed: {
    currentAttachmentTableConfig () {
      if (!this.currentAttachmentTable) return null;
      return this.goodsElevatorTables[this.currentAttachmentTable] || null;
    },
    attachmentColumnIndexes () {
      const cfg = this.currentAttachmentTableConfig;
      if (!cfg || !cfg.columnCount) return [];
      return Array.from({ length: cfg.columnCount }, (_, i) => i);
    }
  },
  created () {
    // 生成唯一的组件ID，避免重复键问题
    this.componentId = 'record-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    // 不在此调用 initializePageOneData：须等 initPageFromRoute 设置 recordInfo 并按设备类型剪枝 pageOneTreeData 后再平铺
    this.initPageFromRoute();
  },
  mounted () {
    // 确保表格渲染完成后设置滚动
    setTimeout(() => {
      this.ensureTableScrollable();
      this.updateResultColumnWidth();
    }, 500);
    window.addEventListener('resize', this.updateResultColumnWidth);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateResultColumnWidth);
  },
  methods: {
    updateResultColumnWidth () {
      this.$nextTick(() => {
        const table = this.$refs.pageOneTable;
        const el = table && table.$el ? table.$el : null;
        if (!el) return;
        const w = el.clientWidth || 0;
        if (!w) return;
        const next = Math.max(220, Math.floor(w * 0.25));
        if (next !== this.resultColumnWidth) {
          this.resultColumnWidth = next;
          if (this.$refs.pageOneTable) {
            this.$refs.pageOneTable.doLayout();
          }
        }
      });
    },
    resultToCheckResult (result) {
      if (result === 'qualified') return 1;
      if (result === 'notApplicable') return -1;
      return 0;
    },
    // 获取某一行“已勾选的检验结果详情文本”，每条换行展示
    getRowSelectedDetailTexts (row) {
      if (!row || !row.itemNumber) return [];
      if (!this.additionalDataList || !Array.isArray(this.additionalDataList.datas)) return [];

      const code = row.itemNumber;
      const targetCheckResult = this.resultToCheckResult(row.result);

      const match = (strictByCheckResult) => this.additionalDataList.datas.find(d => {
        if (!d || !d.dataValue) return false;
        try {
          const parsed = JSON.parse(d.dataValue);
          if (!(Array.isArray(parsed) && parsed.length > 0 && parsed[0] && parsed[0].contentDetailPid)) return false;
          if (parsed[0].configTestItemsContentCode !== code) return false;
          if (!strictByCheckResult) return true;
          return parsed[0].checkResult == null || parsed[0].checkResult === targetCheckResult;
        } catch (e) {
          return false;
        }
      });

      const found = match(true) || match(false);
      if (!found || !found.dataValue) return [];

      try {
        const parsed = JSON.parse(found.dataValue);
        if (!Array.isArray(parsed)) return [];
        return parsed
          .map(item => this.formatDetailContent(item))
          .map(t => (t == null ? '' : String(t)).trim())
          .filter(Boolean);
      } catch (e) {
        return [];
      }
    },
    // 附表 A2.3.2：扶手带速度偏差(%) = (扶手带实测速度 - 梯级/踏板/胶带实测速度) / 梯级/踏板/胶带实测速度 
    calculateHandrailSpeedDeviation (handrailSpeed, actualSpeed) {
      const isEmpty = (v) => v === '' || v === null || v === undefined;
      if (isEmpty(handrailSpeed) || isEmpty(actualSpeed)) {
        return '';
      }
      const handrailValue = Number(handrailSpeed);
      const actualValue = Number(actualSpeed);
      if (!Number.isFinite(handrailValue) || !Number.isFinite(actualValue) || actualValue === 0) {
        return '';
      }
      const deviation = ((handrailValue - actualValue) / actualValue);
      return deviation.toFixed(3);
    },


    // 查看PDF按钮    // 查看PDF按钮
    handlePDF () {
      // console.log(row.status == '1');
      // if (row.status != '9') {
      //   // 弹出选择框让用户选择打印类型
      //   this.$confirm('请选择要查看的内容：', '选择打印类型', {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: '原始记录',
      //     cancelButtonText: '报告',
      //     type: 'info'
      //   }).then(() => {
      //     // 用户选择了原始记录 (type: 1)
      //     this.callPreviewAPI(row.entrustNum, 1);
      //   }).catch(action => {
      //     if (action === 'cancel') {
      //       // 用户选择了报告 (type: 0)
      //       this.callPreviewAPI(row.entrustNum, 0);
      //     }
      //     // 如果是 close，则不执行任何操作
      //   });
      // } else {
      //   this.$message.error('该原始记录未录入，无法查看PDF');
      //   return false;
      // }
      // 用户选择了原始记录 (type: 1)
      this.callPreviewAPI(this.coverInfo.entrustNum, 1);
    },

    // 调用预览PDF的API
    callPreviewAPI (entrustNum, type) {
      // 显示全屏遮罩层
      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      previewTestDataPdf({ entrustNums: [entrustNum], type: type }).then(response => {
        console.log(response);
        loading.close();

        if (response && response.retCode === 'ok' && response.additionalData) {
          // 设置PDF文件名并打开预览弹窗
          this.pdfFileName = response.additionalData + '.pdf';
          this.pdfPreviewVisible = true;
          this.$message.success('PDF生成成功');
        } else {
          this.$message.error(response.retMsg || 'PDF生成失败');
        }
      }).catch(error => {
        console.error('查看PDF失败:', error);
        loading.close();
        this.$message.error('查看PDF失败');
      });
    },
    calculateTable1Deviations (row) {
      if (!row) return;
      // 左侧：(leftHandrailSpeed - actualSpeed) / actualSpeed
      row.leftHandrailDeviation = this.calculateHandrailSpeedDeviation(row.leftHandrailSpeed, row.actualSpeed);
      // 右侧：(rightHandrailSpeed - actualSpeed) / actualSpeed
      row.rightHandrailDeviation = this.calculateHandrailSpeedDeviation(row.rightHandrailSpeed, row.actualSpeed);
    },

    calculateAllTable1Deviations () {
      if (!Array.isArray(this.pageTwoTable1Data)) return;
      this.pageTwoTable1Data.forEach(row => this.calculateTable1Deviations(row));
    },

    // 工具箱 dataKey（提交到 datas，并用于回填）
    getToolboxDataKey () {
      return 'ToolboxNum';
    },

    isToolboxRelatedDataKey (dataKey) {
      if (!dataKey || typeof dataKey !== 'string') return false;
      const key = dataKey.startsWith('*') ? dataKey.substring(1) : dataKey;
      if (key === this.getToolboxDataKey()) return true;
      if (key.startsWith('EquipmentName') || key.startsWith('MgmtNo')) return true;
      if (/^V\d{2}$/.test(key)) return true;
      return false;
    },

    stripToolboxFromReferenceData (source) {
      if (!source || typeof source !== 'object') return source;
      const data = { ...source };
      Object.keys(data).forEach((key) => {
        if (this.isToolboxRelatedDataKey(key)) {
          delete data[key];
        }
      });
      if (Array.isArray(data.datas)) {
        data.datas = data.datas.filter(item => !item || !this.isToolboxRelatedDataKey(item.dataKey));
      }
      return data;
    },

    // 从 additionalData.datas 回填工具箱号
    fillToolboxNum (additionalData) {
      if (!additionalData || !Array.isArray(additionalData.datas)) return;
      const key = this.getToolboxDataKey();
      const found = additionalData.datas.find(d => d && d.dataKey === key);
      if (found && found.dataValue !== undefined && found.dataValue !== null) {
        this.selectedToolboxNum = String(found.dataValue);
      }
    },

    // 判断详情内容是否包含占位符输入框（形如 ${...}，支持多个）
    hasDetailPlaceholders (content) {
      return typeof content === 'string' && /\$\{[^}]*\}/.test(content);
    },
    // 点击整条详情时切换选中状态，提升可点击区域
    toggleDetailSelection (item) {
      if (!item || !item.contentDetailPid) return;
      const pid = item.contentDetailPid;
      const index = this.selectedDetailPids.indexOf(pid);
      if (index > -1) {
        this.selectedDetailPids.splice(index, 1);
      } else {
        this.selectedDetailPids.push(pid);
      }
    },

    // 将详情内容切分为文本段与输入框段，并确保输入数组是响应式的
    // 例如：'允许值${var1}mm,实测值${var2}mm' =>
    // ['允许值', input0, 'mm,实测值', input1, 'mm']
    getDetailContentSegments (item) {
      const content = item && item.detailContent ? String(item.detailContent) : '';
      const pid = item && item.contentDetailPid ? item.contentDetailPid : '';
      const segments = [];
      if (!content) return segments;

      const reg = /\$\{[^}]*\}/g;
      let lastIndex = 0;
      let inputIndex = 0;
      let m;
      while ((m = reg.exec(content)) !== null) {
        if (m.index > lastIndex) {
          segments.push({ type: 'text', value: content.slice(lastIndex, m.index) });
        }
        segments.push({ type: 'input', inputIndex });
        inputIndex++;
        lastIndex = reg.lastIndex;
      }
      if (lastIndex < content.length) {
        segments.push({ type: 'text', value: content.slice(lastIndex) });
      }

      // 初始化/补齐输入数组，确保 v-model 可以正常工作
      if (pid) {
        const existing = this.detailInputValues[pid];
        if (!Array.isArray(existing)) {
          this.$set(this.detailInputValues, pid, Array(inputIndex).fill(''));
        } else if (existing.length < inputIndex) {
          const next = existing.slice();
          while (next.length < inputIndex) next.push('');
          this.$set(this.detailInputValues, pid, next);
        }
      }

      return segments;
    },

    // 校验已勾选的详情项中，包含占位符输入框的必须全部填写
    validateDetailInputs () {
      // 没有详情或没有勾选就不需要校验
      if (!Array.isArray(this.detailList) || this.detailList.length === 0) return true;
      if (!Array.isArray(this.selectedDetailPids) || this.selectedDetailPids.length === 0) return true;

      const invalidItems = this.detailList.filter(item => {
        if (!item || !item.contentDetailPid) return false;
        // 只校验“已勾选且包含占位符”的项
        if (!this.selectedDetailPids.includes(item.contentDetailPid)) return false;
        if (!item.detailContent || !this.hasDetailPlaceholders(item.detailContent)) return false;

        const values = this.detailInputValues[item.contentDetailPid];
        if (!Array.isArray(values) || values.length === 0) return true;
        // 只要有一个是空/全空格，就算不合法
        return values.some(v => v == null || String(v).trim() === '');
      });

      if (invalidItems.length > 0) {
        this.$message.error('请填写勾选详情项中的所有输入值');
        return false;
      }
      return true;
    },

    // 获取检验结果的颜色类
    getResultColorClass (row) {
      if (!row.result) {
        return 'result-none'; // 未选择
      }
      // 无此项：蓝色
      if (row.result === 'notApplicable') {
        return 'result-blue';
      }
      // 只要有附表就是黄色（无论合格/不合格）
      if (row.attachmentTable) {
        return 'result-yellow'; // 有附表：黄色
      }
      // 没有附表时根据结果显示
      if (row.result === 'unqualified') {
        return 'result-gray'; // 不合格：灰色
      }
      return 'result-green'; // 合格：绿色
    },

    // 获取综合检验结果的颜色类
    getAutoResultColorClass (autoResult) {
      if (!autoResult) {
        return 'result-none';
      }
      if (autoResult === 'unqualified') {
        return 'result-gray'; // 不合格：灰色
      }
      if (autoResult === 'notApplicable') {
        return 'result-blue'; // 无此项：蓝色
      }
      return 'result-green'; // 合格：绿色
    },

    // 获取结果显示文本
    getResultText (result) {
      if (!result) return '未选择';
      if (result === 'qualified') return '符合';
      if (result === 'notApplicable') return '无此项';
      return '不符合';
    },

    // 获取结果标题提示
    getResultTitle (row) {
      if (!row.result) return '点击选择检验结果';
      const resultText = this.getResultText(row.result);
      if (row.attachmentTable) {
        return `${resultText}（有附表）- 点击编辑`;
      }
      return `${resultText} - 点击编辑`;
    },

    // 判断是否为最小项（叶子节点）
    isLeafItem (row) {
      return !!row && (!Array.isArray(row.children) || row.children.length === 0);
    },
    pageOneTableCellStyle ({ row, columnIndex }) {
      const style = { textAlign: 'left' };
      if (columnIndex === 0 && this.isLeafItem(row) && !!row.hasOpenedResultDialog) {
        style.backgroundColor = '#aed5ff';
      }
      return style;
    },

    // 打开检验结果编辑弹窗
    openResultDialog (row) {
      if (row) {
        this.$set(row, 'hasOpenedResultDialog', true);
        // 同步写回树数据，避免 saveResult 后重新 flatten 导致图标状态丢失
        const updateVisitedFlag = (nodes) => {
          if (!Array.isArray(nodes)) return false;
          for (const node of nodes) {
            if (node.id === row.originalId || node.id === row.id) {
              this.$set(node, 'hasOpenedResultDialog', true);
              return true;
            }
            if (node.children && updateVisitedFlag(node.children)) {
              return true;
            }
          }
          return false;
        };
        updateVisitedFlag(this.pageOneTreeData);
      }
      this.currentEditRow = row;
      this.initialEditRowResult = row ? row.result : null;
      this.tempResult = row ? (row.result || null) : null;
      this.resultDialogVisible = true;
      // 初始化详情列表相关数据
      this.detailList = [];
      this.selectedDetailPids = [];
      this.detailInputValues = {};
      this.initialDialogSelectedDetailPids = [];
      this.initialDialogDetailInputValues = {};
      // 打开弹窗时调用接口获取详情列表
      this.loadDetailList();
    },

    // 加载详情列表
    async loadDetailList () {
      if (!this.currentEditRow || !this.currentEditRow.itemNumber) {
        return;
      }

      // 转换result为checkResult (1=符合, 0=不符合, -1=无此项)
      let checkResult = 0;
      const currentResult = this.tempResult != null ? this.tempResult : this.currentEditRow.result;
      if (currentResult === 'qualified') {
        checkResult = 1;
      } else if (currentResult === 'notApplicable') {
        checkResult = -1;
      } else {
        checkResult = 0;
      }

      this.detailListLoading = true;
      try {
        const response = await queryDetailListByContentCode({
          configReportPid: this.recordData.configReportPid,
          configTestItemsContentCode: this.currentEditRow.itemNumber,
          checkResult: checkResult
        });

        if (response && response.additionalData && Array.isArray(response.additionalData)) {
          this.detailList = response.additionalData;
        } else {
          this.detailList = [];
        }

        // 加载完列表后，尝试从本地存储或反填数据中恢复
        this.restoreDetailData();
      } catch (error) {
        console.error('加载详情列表失败:', error);
        this.$message.error('加载详情列表失败');
        this.detailList = [];
      } finally {
        this.detailListLoading = false;
      }
    },

    // 监听检验结果变化
    handleResultChange (value) {
      // 当结果变化时，重新加载详情列表
      this.loadDetailList();
    },

    onResultDialogClose (done) {
      // 取消/关闭：回滚弹窗内未确认的修改
      if (this.currentEditRow) {
        this.currentEditRow.result = this.initialEditRowResult;
      }
      this.tempResult = this.initialEditRowResult;
      this.selectedDetailPids = Array.isArray(this.initialDialogSelectedDetailPids) ? [...this.initialDialogSelectedDetailPids] : [];
      this.detailInputValues = this.initialDialogDetailInputValues ? JSON.parse(JSON.stringify(this.initialDialogDetailInputValues)) : {};

      this.resultDialogVisible = false;
      if (typeof done === 'function') done();
    },

    // 从本地存储或反填数据中恢复详情数据
    // 逻辑参考 RecordDialog.vue，按 configTestItemsContentCode（即 itemNumber）来匹配数据，
    // 而不是直接用 dataKey，从而兼容 dataKey 为 detailCode（如 A2.2.1.1.1-4）的情况
    restoreDetailData () {
      if (!this.currentEditRow || !this.currentEditRow.itemNumber) {
        return;
      }

      // 弹窗内优先使用临时结果，避免未保存时写回原数据
      const currentResult = this.tempResult != null ? this.tempResult : this.currentEditRow.result;
      const originalId = this.currentEditRow.itemNumber;
      // 转换result为checkResult (1=符合, 0=不符合, -1=无此项)
      let currentCheckResult = 0;
      if (currentResult === 'qualified') {
        currentCheckResult = 1;
      } else if (currentResult === 'notApplicable') {
        currentCheckResult = -1;
      } else {
        currentCheckResult = 0;
      }

      if (this.additionalDataList && this.additionalDataList.datas && Array.isArray(this.additionalDataList.datas)) {
        // 先按“同一检验项 + 同一状态(checkResult)”精确匹配；匹配不到再兜底匹配同一检验项
        const findSavedData = (strictByCheckResult) => this.additionalDataList.datas.find(d => {
          if (!d || !d.dataValue) return false;
          try {
            const parsed = JSON.parse(d.dataValue);
            if (!(Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid)) return false;
            if (parsed[0].configTestItemsContentCode !== originalId) return false;
            if (!strictByCheckResult) return true;
            return parsed[0].checkResult == null || parsed[0].checkResult === currentCheckResult;
          } catch (e) {
            return false;
          }
        });
        const savedData = findSavedData(true) || findSavedData(false);

        if (savedData && savedData.dataValue) {
          try {
            const parsedData = JSON.parse(savedData.dataValue);
            if (Array.isArray(parsedData) && parsedData.length > 0) {
              const pids = parsedData.map(item => item.contentDetailPid).filter(pid => pid);

              // 记录打开弹窗时的初始详情PID列表
              this.$set(this.initialSelectedDetailPids, originalId, pids);

              // 恢复选中状态（先清空再赋值，避免渲染不同步问题）
              this.selectedDetailPids = [];
              this.$nextTick(() => {
                this.selectedDetailPids = pids;
                // 仅在首次打开弹窗时记录快照，用于“取消/关闭”回滚
                if (this.resultDialogVisible && Array.isArray(this.initialDialogSelectedDetailPids) && this.initialDialogSelectedDetailPids.length === 0) {
                  this.initialDialogSelectedDetailPids = [...pids];
                  this.initialDialogDetailInputValues = JSON.parse(JSON.stringify(this.detailInputValues || {}));
                }
              });

              // 恢复输入框的值
              parsedData.forEach(item => {
                if (item.detailContent && item.contentDetailPid) {
                  // 解析所有 ${...}，支持多个输入框（保存时会写回为 ${值}）
                  if (this.hasDetailPlaceholders(item.detailContent)) {
                    const reg = /\$\{([^}]*)\}/g;
                    const values = [];
                    let m;
                    while ((m = reg.exec(item.detailContent)) !== null) {
                      values.push(m[1] != null ? m[1] : '');
                    }
                    if (values.length > 0) {
                      this.$set(this.detailInputValues, item.contentDetailPid, values);
                    }
                  } else if (item.detailContent.startsWith('其他:')) {
                    // 兼容旧保存格式：其他:xxx => 作为单输入框数组
                    const inputValue = item.detailContent.substring(3);
                    this.$set(this.detailInputValues, item.contentDetailPid, [inputValue]);
                  }
                }
              });
            }
          } catch (e) {
            console.error('解析保存的数据失败:', e);
          }
        } else {
          // 没有匹配到保存的数据，记录为空数组（打开弹窗时的初始状态）
          this.$set(this.initialSelectedDetailPids, originalId, []);
        }
      } else {
        // 如果没有 additionalDataList，记录为空数组（打开弹窗时的初始状态）
        this.$set(this.initialSelectedDetailPids, originalId, []);
      }
    },

    // 打开附表查看弹窗
    openAttachmentDialog (tableId) {
      this.attachmentDialogBackup = this.getAttachmentTableSnapshot(tableId);
      this.currentAttachmentTable = tableId;
      this.attachmentDialogVisible = true;
    },

    getAttachmentTableSnapshot (tableId) {
      const tableConfig = this.goodsElevatorTables[tableId];
      return {
        tableId,
        data: tableConfig ? JSON.parse(JSON.stringify(tableConfig)) : null
      };
    },

    // 关闭附表弹窗：不保存，恢复到打开时快照
    handleAttachmentDialogClose (done) {
      const backup = this.attachmentDialogBackup;
      if (backup && backup.tableId === this.currentAttachmentTable && backup.data !== null) {
        this.$set(this.goodsElevatorTables, backup.tableId, JSON.parse(JSON.stringify(backup.data)));
      }
      this.attachmentDialogBackup = null;
      this.attachmentDialogVisible = false;
      if (typeof done === 'function') {
        done();
      }
    },

    // 保存附表弹窗：保留当前填写值并关闭
    handleAttachmentDialogSave () {
      this.syncAdditionalDataListPageTwoFromUI();
      this.attachmentDialogBackup = null;
      this.attachmentDialogVisible = false;
      this.$message.success('附表数据已保存');
    },

    getGoodsElevatorCellValue (colIndex, rowKey) {
      const cfg = this.currentAttachmentTableConfig;
      if (!cfg || !cfg.columns[colIndex] || !cfg.columns[colIndex].values) return '';
      const val = cfg.columns[colIndex].values[rowKey];
      return val == null ? '' : val;
    },

    setGoodsElevatorCellValue (colIndex, rowKey, value) {
      const tableId = this.currentAttachmentTable;
      const cfg = tableId && this.goodsElevatorTables[tableId];
      if (!cfg || !cfg.columns[colIndex]) return;
      if (!cfg.columns[colIndex].values) {
        this.$set(cfg.columns[colIndex], 'values', {});
      }
      this.$set(cfg.columns[colIndex].values, rowKey, value == null ? '' : value);
    },

    // 用当前附表 UI 状态覆盖 additionalDataList 中的附表项，清空的单元格不再保留旧 dataKey
    syncAdditionalDataListPageTwoFromUI () {
      if (!this.additionalDataList) {
        this.additionalDataList = {};
      }
      if (!Array.isArray(this.additionalDataList.datas)) {
        this.additionalDataList.datas = [];
      }
      const pageTwoDatas = this.savePageTwoData();
      const nonPageTwoDatas = this.additionalDataList.datas.filter(item => {
        if (!item || !item.dataKey) return false;
        const key = item.dataKey.startsWith('*') ? item.dataKey.substring(1) : item.dataKey;
        return !this.isPageTwoDataKey(key);
      });
      this.additionalDataList.datas = [...nonPageTwoDatas, ...pageTwoDatas];
    },

    // 保存检验结果
    saveResult (result) {
      if (this.currentEditRow) {
        // 先校验勾选项中的输入框是否已全部填写
        if (!this.validateDetailInputs()) {
          return;
        }

        const finalResult = result != null ? result : (this.tempResult != null ? this.tempResult : this.currentEditRow.result);
        const originalId = this.currentEditRow.itemNumber;
        // 页面1对齐：不符合且未勾选详情时，不中断保存，而是写入 infoList 自定义记录
        this.syncUnqualifiedCustomInfoList(originalId, finalResult);

        this.currentEditRow.result = finalResult;
        this.updateTreeDataResult(this.currentEditRow.id, finalResult);

        // 保存详情数据到本地存储
        this.saveDetailDataToLocal();
      }
      this.resultDialogVisible = false;
      this.tempResult = null;
    },
    // 同步“不符合且未勾选详情”的 infoList 自定义记录
    syncUnqualifiedCustomInfoList (originalId, finalResult) {
      if (!originalId) return;
      if (!Array.isArray(this.unqualifiedCustomInfoList)) {
        this.unqualifiedCustomInfoList = [];
      }

      // 先清理该检验项旧记录，再按当前状态决定是否新增
      this.unqualifiedCustomInfoList = this.unqualifiedCustomInfoList.filter(
        item => item && item.configTestItemsContentCode !== originalId
      );

      const hasSelectedDetails = Array.isArray(this.selectedDetailPids) && this.selectedDetailPids.length > 0;
      if (finalResult !== 'unqualified' || hasSelectedDetails) return;

      const queryLikePayload = [{
        configReportPid: this.recordData ? this.recordData.configReportPid : null,
        configTestItemsContentCode: originalId,
        checkResult: 0,
        detailContent: ' '
      }];

      this.unqualifiedCustomInfoList.push({
        testItemChildName: this.getTestItemChildName(originalId),
        configTestItemsContentCode: originalId,
        unqualifiedDetail: JSON.stringify(queryLikePayload)
      });
    },
    // 从后端 additionalData.infoList 恢复“空详情占位”记录
    // 只恢复：
    // - checkResult = 0
    // - detailContent 为空/空白
    // - 且没有 contentDetailPid（非真实详情）
    // “详见附表xxx”不在这里恢复，仍由 buildInfoList 根据 CheckFloorX 动态生成。
    restoreUnqualifiedCustomInfoList (additionalData) {
      this.unqualifiedCustomInfoList = [];
      if (!additionalData) return;

      const source = additionalData.infoList;
      if (!source) return;

      let list = [];
      if (Array.isArray(source)) {
        list = source;
      } else if (typeof source === 'string') {
        try {
          const parsed = JSON.parse(source);
          if (Array.isArray(parsed)) {
            list = parsed;
          }
        } catch (e) {
          list = [];
        }
      }
      if (!Array.isArray(list) || list.length === 0) return;

      const isBlankPlaceholder = (detail) => {
        if (!detail || Number(detail.checkResult) !== 0) return false;
        if (detail.contentDetailPid) return false;
        const text = detail.detailContent == null ? '' : String(detail.detailContent).trim();
        if (text.startsWith('详见附表')) return false;
        return text === '';
      };

      const picked = [];
      list.forEach(item => {
        if (!item || !item.configTestItemsContentCode || !item.unqualifiedDetail) return;
        try {
          const details = JSON.parse(item.unqualifiedDetail);
          if (!Array.isArray(details) || details.length === 0) return;
          const hasBlankPlaceholder = details.some(isBlankPlaceholder);
          if (!hasBlankPlaceholder) return;

          picked.push({
            testItemChildName: item.testItemChildName || this.getTestItemChildName(item.configTestItemsContentCode),
            configTestItemsContentCode: item.configTestItemsContentCode,
            unqualifiedDetail: JSON.stringify([{
              configReportPid: (this.recordData && this.recordData.configReportPid) || null,
              configTestItemsContentCode: item.configTestItemsContentCode,
              checkResult: 0,
              detailContent: ' '
            }])
          });
        } catch (e) {
          // ignore invalid unqualifiedDetail json
        }
      });

      if (picked.length === 0) return;
      const uniqueMap = new Map();
      picked.forEach(item => {
        uniqueMap.set(item.configTestItemsContentCode, item);
      });
      this.unqualifiedCustomInfoList = Array.from(uniqueMap.values());
    },

    // 保存详情数据到本地存储（存储在additionalDataList.datas中）
    saveDetailDataToLocal () {
      if (!this.currentEditRow || !this.currentEditRow.itemNumber) {
        return;
      }

      const originalId = this.currentEditRow.itemNumber;
      // 转换result为checkResult (1=符合, 0=不符合, -1=无此项)
      let currentCheckResult = 0;
      if (this.currentEditRow.result === 'qualified') {
        currentCheckResult = 1;
      } else if (this.currentEditRow.result === 'notApplicable') {
        currentCheckResult = -1;
      } else {
        currentCheckResult = 0;
      }

      // 构建要保存的数据
      const savedData = this.detailList
        .filter(item => this.selectedDetailPids.includes(item.contentDetailPid))
        .map(item => {
          const dataItem = { ...item };
          dataItem.checkResult = currentCheckResult;

          // 处理包含占位符的内容：把输入框的值回填为 ${值}，以便下次打开能识别输入框及其值
          if (item.detailContent && this.hasDetailPlaceholders(item.detailContent)) {
            const values = Array.isArray(this.detailInputValues[item.contentDetailPid])
              ? this.detailInputValues[item.contentDetailPid]
              : [];
            let valueIndex = 0;
            dataItem.detailContent = item.detailContent.replace(/\$\{[^}]*\}/g, () => {
              const v = values[valueIndex] != null ? String(values[valueIndex]) : '';
              valueIndex++;
              return `\$\{${v}\}`;
            });
          }

          return dataItem;
        });

      // 确保additionalDataList存在
      if (!this.additionalDataList) {
        this.additionalDataList = {};
      }
      if (!this.additionalDataList.datas) {
        this.additionalDataList.datas = [];
      }

      // 详情数据提交时的 dataKey 优先用 detailCode（比 itemNumber 小一级），避免覆盖子项结果
      const detailDataKey = savedData && savedData.length > 0 && savedData[0].detailCode ? savedData[0].detailCode : originalId;

      // 找出“同一检验项 + 同一状态(checkResult)”的旧记录（无论 dataKey 是 itemNumber 还是 detailCode）
      const matchIndices = [];
      for (let i = 0; i < this.additionalDataList.datas.length; i++) {
        const d = this.additionalDataList.datas[i];
        if (!d || !d.dataValue) continue;
        try {
          const parsed = JSON.parse(d.dataValue);
          if (!(Array.isArray(parsed) && parsed.length > 0 && parsed[0] && parsed[0].contentDetailPid)) continue;
          if (parsed[0].configTestItemsContentCode !== originalId) continue;
          const cr = (parsed[0].checkResult === undefined || parsed[0].checkResult === null) ? currentCheckResult : parsed[0].checkResult;
          if (cr === currentCheckResult) {
            matchIndices.push(i);
          }
        } catch (e) {
          // ignore
        }
      }
      const primaryIndex = matchIndices.length > 0 ? matchIndices[0] : -1;

      if (savedData.length > 0) {
        const dataItem = {
          dataKey: detailDataKey,
          dataValue: JSON.stringify(savedData)
        };

        if (primaryIndex >= 0) {
          // 覆盖旧记录（无论旧 dataKey 是什么）
          this.additionalDataList.datas[primaryIndex] = dataItem;
          // 删除其它重复记录（从后往前删避免索引错乱）
          for (let k = matchIndices.length - 1; k >= 1; k--) {
            this.additionalDataList.datas.splice(matchIndices[k], 1);
          }
        } else {
          // 添加新数据
          this.additionalDataList.datas.push(dataItem);
        }
      } else if (primaryIndex >= 0) {
        // 如果没有选中任何数据，删除当前状态下已保存的数据（包括重复的）
        for (let k = matchIndices.length - 1; k >= 0; k--) {
          this.additionalDataList.datas.splice(matchIndices[k], 1);
        }
        // 注意：不更新 initialSelectedDetailPids，保持初始状态
      }
    },

    // 初始化 initialSelectedDetailPids，从 additionalDataList 中读取页面加载时的初始状态（用于判断新勾选的项）
    initPreviousSelectedDetailPids () {
      this.initialSelectedDetailPids = {};

      if (!this.additionalDataList || !this.additionalDataList.datas || !Array.isArray(this.additionalDataList.datas)) {
        return;
      }

      // 遍历所有详情数据，记录每个检验项的已保存详情PID列表（这是页面加载时的初始状态）
      this.additionalDataList.datas.forEach(item => {
        if (!item || !item.dataValue) return;

        try {
          const parsed = JSON.parse(item.dataValue);
          if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid) {
            const configTestItemsContentCode = parsed[0].configTestItemsContentCode;
            if (configTestItemsContentCode) {
              // 记录该检验项的所有已保存详情PID（页面加载时的初始状态）
              this.$set(this.initialSelectedDetailPids, configTestItemsContentCode,
                parsed.map(detail => detail.contentDetailPid).filter(pid => pid));
            }
          }
        } catch (e) {
          // 忽略解析错误
        }
      });

      console.log('初始化 initialSelectedDetailPids (页面加载时的初始状态):', this.initialSelectedDetailPids);
    },

    // 格式化详情文本，处理${}占位符的情况
    formatDetailContent (detailItem) {
      if (!detailItem || !detailItem.detailContent) {
        return '';
      }

      let content = String(detailItem.detailContent);

      // 如果包含${}占位符，需要替换为实际值
      // 详情数据在保存时，${}已经被替换为${值}的格式
      // 例如：'允许值${var1}mm' 保存后变成 '允许值${333}mm'
      // 我们需要提取${}中的值并替换，只保留值，不保留${}符号
      if (this.hasDetailPlaceholders(content)) {
        const reg = /\$\{([^}]*)\}/g;
        content = content.replace(reg, (match, value) => {
          // 如果${}中有值，就使用这个值；如果没有值，保持空字符串
          return value != null && value !== '' ? value : '';
        });
      }

      return content;
    },

    // 获取附表标题
    getAttachmentTitle (tableId) {
      const id = tableId || this.currentAttachmentTable;
      return GOODS_ELEVATOR_ATTACHMENT_TITLES[id] || '附表';
    },

    getAttachmentInfoText (tableId) {
      const title = GOODS_ELEVATOR_ATTACHMENT_TITLES[tableId] || '';
      if (!title) return '附表';
      const match = title.match(/A3\.[\d.()（）]+/);
      return match ? match[0] : title;
    },

    // 获取检测人员列表
    async getDetectionPersonnelOptions () {
      try {
        const response = await queryEmployeeDropdown({ sginType: 'Test', configReportPid: this.recordData.configReportPid });
        console.log(response);
        if (response && response.additionalData) {
          this.detectionPersonnelOptions = response.additionalData.map(item => ({
            label: item.employeeName || item.label,
            value: item.employeePid || item.value
          }));
          this.reviewPersonnelOptions = response.additionalData.map(item => ({
            label: item.employeeName || item.label,
            value: item.employeePid || item.value
          }));
        }
      } catch (error) {
        console.error('获取检测人员列表失败:', error);
        this.$message.error('获取检测人员列表失败');
      }
    },

    // 获取校核人员列表
    // async getReviewPersonnelOptions () {
    //   try {
    //     const response = await queryEmployeeDropdown({ sginType: 'Check', configReportPid: this.recordData.configReportPid });
    //     console.log(response);
    //     if (response && response.additionalData) {
    //       this.reviewPersonnelOptions = response.additionalData.map(item => ({
    //         label: item.employeeName || item.label,
    //         value: item.employeePid || item.value
    //       }));
    //        this.detectionPersonnelOptions = response.additionalData.map(item => ({
    //         label: item.employeeName || item.label,
    //         value: item.employeePid || item.value
    //       }));
    //     }
    //   } catch (error) {
    //     console.error('获取校核人员列表失败:', error);
    //     this.$message.error('获取校核人员列表失败');
    //   }
    // },

    // 获取设备列表
    async getEquipmentOptions () {
      try {
        const response = await queryEqptList({
          currPage: 1,
          pageSize: 10000,
          configReportPid: this.recordData.configReportPid,
        });
        console.log('设备列表响应:', response);

        if (response && response.retCode === 'ok' && response.additionalData && response.additionalData.records) {
          this.equipmentOptions = response.additionalData.records.map((item, index) => ({
            label: item.eqptName || item.name, // 设备名称
            value: item.configReportPid || item.id || `equipment-${index}`, // 设备ID，确保唯一性
            managementNumber: item.eqptNum || item.managementNumber || '' // 管理编号
          }));
        }
      } catch (error) {
        console.error('获取设备列表失败:', error);
        this.$message.error('获取设备列表失败');
      }
    },

    // 自动加载工具箱和绑定设备（扶梯）
    async loadToolboxEqptInfos () {
      try {
        const response = await queryToolboxEqptInfos({ usageScenario: '扶梯' });
        if (response && response.retCode === 'ok') {
          const additionalData = (response && response.additionalData) ? response.additionalData : {};
          const deviceList = Array.isArray(additionalData.eqptInfos) ? additionalData.eqptInfos : [];
          this.selectedToolboxNum = additionalData.toolboxName || '';

          this.instrumentTableData.forEach(row => {
            row.name = '';
            row.managementNumber = '';
            row.usageRecord = '';
            row.name2 = '';
            row.managementNumber2 = '';
            row.usageRecord2 = '';
          });

          for (let i = 0; i < Math.min(deviceList.length, 20); i++) {
            const device = deviceList[i] || {};
            const targetRow = i < 10 ? this.instrumentTableData[i] : this.instrumentTableData[i - 10];
            const targetNameField = i < 10 ? 'name' : 'name2';
            const targetManagementNumberField = i < 10 ? 'managementNumber' : 'managementNumber2';
            const usageColumn = i < 10 ? 'first' : 'second';
            const eqptNum = device.eqptNum || '';
            const eqptName = device.eqptName || '';

            let equipmentOption = this.equipmentOptions.find(opt => opt.managementNumber === eqptNum);
            if (!equipmentOption && eqptNum) {
              const dynamicValue = `toolbox-${eqptNum}`;
              equipmentOption = {
                label: eqptName || eqptNum,
                value: dynamicValue,
                managementNumber: eqptNum
              };
              this.equipmentOptions.push(equipmentOption);
            }

            if (targetRow) {
              targetRow[targetNameField] = equipmentOption ? equipmentOption.value : '';
              targetRow[targetManagementNumberField] = eqptNum;
              this.autoFillUsageRecord(targetRow, usageColumn);
            }
          }

          this.updateSelectedEquipments();
          return true;
        } else {
          this.$message.error(response.retMsg || '获取工具箱设备失败');
          return false;
        }
      } catch (error) {
        console.error('获取工具箱设备失败:', error);
        this.$message.error('获取工具箱设备失败');
        return false;
      }
    },

    // 默认配置：统一走 queryToolboxEqptInfos（loadToolboxEqptInfos）覆盖仪器表
    async handleRestoreDefaultToolbox () {
      this.toolboxRestoreLoading = true;
      let pendingMsg = null;
      try {
        pendingMsg = this.$message({
          type: 'info',
          message: '正在从服务器恢复工具箱配置，请稍候…',
          duration: 0,
          showClose: true
        });
        const ok = await this.loadToolboxEqptInfos();
        if (ok) {
          this.$message.success('已恢复默认工具箱配置');
        }
      } finally {
        if (pendingMsg && typeof pendingMsg.close === 'function') {
          pendingMsg.close();
        }
        this.toolboxRestoreLoading = false;
      }
    },

    // 设备选择变化处理
    onEquipmentChange (row, fieldName, selectedValue) {
      console.log('设备选择变化:', row, fieldName, selectedValue);

      // 找到选中的设备信息
      const selectedEquipment = this.equipmentOptions.find(item => item.value === selectedValue);
      if (selectedEquipment) {
        // 自动填充管理编号
        if (fieldName === 'name') {
          row.managementNumber = selectedEquipment.managementNumber;
          // 自动填充使用记录
          this.autoFillUsageRecord(row, 'first');
          // 更新已选设备列表
          this.updateSelectedEquipments();
        } else if (fieldName === 'name2') {
          row.managementNumber2 = selectedEquipment.managementNumber;
          // 自动填充使用记录
          this.autoFillUsageRecord(row, 'second');
          // 更新已选设备列表
          this.updateSelectedEquipments();
        }
      }
    },

    // 自动填充使用记录
    autoFillUsageRecord (row, column) {
      if (!row) return;

      if (column === 'first') {
        // 第一列：如果name和managementNumber都有值，则自动填充usageRecord为'✓'
        if (row.name && row.managementNumber) {
          row.usageRecord = '✓';
        } else {
          // 如果任一字段为空，则清空usageRecord
          row.usageRecord = '';
        }
      } else if (column === 'second') {
        // 第二列：如果name2和managementNumber2都有值，则自动填充usageRecord2为'✓'
        if (row.name2 && row.managementNumber2) {
          row.usageRecord2 = '✓';
        } else {
          // 如果任一字段为空，则清空usageRecord2
          row.usageRecord2 = '';
        }
      }
    },

    // 更新已选设备ID列表
    updateSelectedEquipments () {
      this.selectedEquipmentIds = [];
      this.instrumentTableData.forEach(row => {
        if (row.name) {
          this.selectedEquipmentIds.push(row.name);
        }
        if (row.name2) {
          this.selectedEquipmentIds.push(row.name2);
        }
      });
      console.log('已选设备列表:', this.selectedEquipmentIds);
    },

    // 删除仪器设备（逻辑上是 20 条：01-20；UI 用 10 行拆成两列展示）
    // 点击左/右列删除时，仅删除对应的一条，再整体前移并补空，最后重排序号
    handleInstrumentDelete (row, side = 'left') {
      if (!row) return;
      const rowIndex = this.instrumentTableData.findIndex(r => r && r.id === row.id);
      if (rowIndex === -1) return;

      const flat = [];
      for (let i = 0; i < 10; i++) {
        const r = this.instrumentTableData[i] || {};
        flat.push({
          name: r.name || '',
          managementNumber: r.managementNumber || '',
          usageRecord: r.usageRecord || ''
        });
      }
      for (let i = 0; i < 10; i++) {
        const r = this.instrumentTableData[i] || {};
        flat.push({
          name: r.name2 || '',
          managementNumber: r.managementNumber2 || '',
          usageRecord: r.usageRecord2 || ''
        });
      }

      const deleteIndex = side === 'right' ? rowIndex + 10 : rowIndex;
      const isFilled = item => item && (item.name || item.managementNumber || item.usageRecord);
      const filledCount = flat.filter(isFilled).length;
      if (filledCount <= 1 && isFilled(flat[deleteIndex])) {
        this.$message.warning('当前仅剩最后一条仪器设备数据，不允许删除');
        return;
      }

      this.$confirm('确定删除该行数据吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          // 2) 仅删除当前点击侧对应的一条
          if (deleteIndex >= 0 && deleteIndex < flat.length) {
            flat.splice(deleteIndex, 1);
          }

          // 3) 过滤空条目并补齐到 20 条（保持提交时 EquipmentName01-20 下标稳定）
          const compact = flat.filter(item => item && (item.name || item.managementNumber || item.usageRecord));
          while (compact.length < 20) {
            compact.push({ name: '', managementNumber: '', usageRecord: '' });
          }

          // 4) 回写到 10 行两列展示结构（不改变 instrumentTableData 的行数和 row-key）
          for (let i = 0; i < 10; i++) {
            const targetRow = this.instrumentTableData[i];
            if (!targetRow) continue;

            const left = compact[i] || { name: '', managementNumber: '', usageRecord: '' };
            const right = compact[i + 10] || { name: '', managementNumber: '', usageRecord: '' };

            this.$set(targetRow, 'serialNumber', i + 1);
            this.$set(targetRow, 'name', left.name);
            this.$set(targetRow, 'managementNumber', left.managementNumber);
            this.$set(targetRow, 'usageRecord', left.usageRecord);

            this.$set(targetRow, 'serialNumber2', i + 11);
            this.$set(targetRow, 'name2', right.name);
            this.$set(targetRow, 'managementNumber2', right.managementNumber);
            this.$set(targetRow, 'usageRecord2', right.usageRecord);
          }

          // 5) 更新下拉选项过滤状态
          this.updateSelectedEquipments();

          // this.$message.success('删除成功');
        })
        .catch(() => { });
    },

    // 获取可用的设备选项（过滤已选择的设备）
    getAvailableEquipment (currentRow, fieldName) {
      return this.equipmentOptions.filter(item => {
        // 如果是当前行的当前字段，则不过滤（允许重新选择）
        const currentValue = currentRow[fieldName];
        if (currentValue === item.value) {
          return true;
        }

        // 过滤掉已经被其他行选择的设备
        return !this.selectedEquipmentIds.includes(item.value);
      });
    },

    // 根据设备ID获取设备名称
    getEquipmentNameById (equipmentId) {
      if (!equipmentId) return '';
      const equipment = this.equipmentOptions.find(item => item.value === equipmentId);
      return equipment ? equipment.label : equipmentId;
    },

    // 根据设备名称获取设备ID
    getEquipmentIdByName (equipmentName) {
      if (!equipmentName) return '';
      const equipment = this.equipmentOptions.find(item => item.label === equipmentName);
      return equipment ? equipment.value : equipmentName;
    },

    // 加载之前暂存的数据
    async loadSavedData (entrustNum, status, FIRST_YEAR) {
      try {
        const response = status === 9 ? await queryTestDataInfo(entrustNum, FIRST_YEAR) : await queryTestDataTest(entrustNum, FIRST_YEAR);
        console.log('获取到的暂存数据:', response);

        if (response && response.retCode === 'ok' && response.additionalData) {
          // 反填数据到对应的字段
          this.additionalDataList = response.additionalData
          this.fillFormData(response.additionalData);
          // 初始化 initialSelectedDetailPids，记录所有已保存的详情PID
          this.initPreviousSelectedDetailPids()
        }
      } catch (error) {
        console.error('获取暂存数据失败:', error);
        // 不显示错误消息，因为可能是第一次创建，没有暂存数据
      }
    },

    // 将API返回的数据反填到表单中
    // options.skipToolbox: 参照场景为 true，不覆盖工具箱号与仪器设备表
    fillFormData (additionalData, options = {}) {
      if (!additionalData) return;
      const skipToolbox = !!(options && options.skipToolbox);

      console.log('开始反填数据:', additionalData);

      try {
        // 反填设备信息
        this.fillEquipmentInfo(additionalData);

        // 反填封面信息
        this.fillCoverInfo(additionalData);

        if (!skipToolbox) {
          this.fillToolboxNum(additionalData);
          this.fillInstrumentData(additionalData);
        }

        // 如果有其他数据格式（如原来的datas数组），也进行处理
        if (additionalData.datas && Array.isArray(additionalData.datas)) {
          this.fillLegacyData(additionalData.datas);
          // 反填详情数据
          this.fillDetailData(additionalData.datas);
        }

        // 反填“infoList里的空详情占位”到本地缓存：
        // 场景：不符合且未勾选详情时，该记录只存在 infoList，不存在 datas。
        // 若不恢复，重新打开后不操作直接保存会丢失该类记录。
        this.restoreUnqualifiedCustomInfoList(additionalData);

        console.log('数据回填完成');
      } catch (error) {
        console.error('数据回填过程中发生错误:', error);
        this.$message.warning('部分数据回填失败，请检查数据格式');
      }
    },

    // 反填设备信息
    fillEquipmentInfo (additionalData) {
      // 设备信息字段映射
      const equipmentMapping = {
        'USE_UNT_NAME': 'useUnitName', // 使用单位名称
        'EQP_INNER_COD': 'unitInternalNumber', // 单位内编号
        'USE_UNT_COD': 'USE_UNT_COD', // 统一信用代码
        'EQP_VART_NAME': 'equipmentType', // 设备品种
        'EQP_AREA_NAME': 'installLocation', // 设备安装地点
        'EQP_MOD': 'productModel', // 产品型号
        'EQP_USECERT_COD': 'registrationNumber', // 使用登记证号
        'FACTORY_COD': 'productNumber', // 产品编号
        'MAKE_UNT_NAME': 'manufacturerName', // 制造单位名称
        'MAKE_DATE': 'manufactureDate', // 制造日期
        'SAFE_MEN': 'safetyManager', // 安管人员
        'RATEDLOAD': 'ratedLoad', // 额定载重量
        'CONTROL_TYPE': 'controlMethod', // 控制方式
        'EQP_USE_ADDR': 'eqpUseAddr', // 使用地址（与 EQP_AREA_NAME 区分）
        'EQP_NAME': 'equipmentName', // 设备名称
        'EQP_SORT_NAME': 'eqpSortName', // 设备类别（与封面 EQP_SORT_NAME 同步）
        'OIDNO': 'oidNo', // 设备编号
        'EQP_TEMP_NAME': 'eqpTempName', // 设备型式
        'EQP_REG_COD': 'eqpRegCod', // 注册代码
        'FIRST_YEAR': 'firstYear', // 首检年份
        'standardData': 'standardData', // 检测依据
        'RATEDVELOCITY': 'ratedSpeed', // 额定速度(m/s)
        'renovation_unt_name': 'renovationUnitName', // 改造单位名称
        'renovation_date': 'renovationDate', // 改造日期
        'service_unt_name': 'maintenanceUnit', // 维护保养单位
        'RUNVELOCITY': 'nominalSpeed', // 名义速度(m/s)
        'DIP_ANGLE': 'inclinationAngle', // 倾斜角(°)
        'NOMI_WIDTH': 'nominalWidth', // 名义宽度(mm)
        'TRANSPORT_CAPACITY': 'transportCapacity', // 输送能力(P/h)
        'SLIDWAY_USE_LENG': 'sectionLength', // 使用区段长度(m)
        'ELEHEIGHT': 'liftHeight', // 提升高度(m)
        'powerSupply': 'powerSupply', // 电源
        'humidity': 'humidity', // 湿度
        'temperature': 'temperature', // 温度
      };

      // 遍历映射关系，将数据填入对应字段
      Object.keys(equipmentMapping).forEach(apiKey => {
        if (additionalData[apiKey] !== undefined) {
          const formKey = equipmentMapping[apiKey];
          let value = additionalData[apiKey];

          // 特殊处理日期格式
          if (formKey === 'manufactureDate' && value) {
            // manufactureDate 使用 YYYY-MM-DD 格式
            if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
              value = value;
            } else {
              // 尝试格式化日期
              const date = new Date(value);
              if (!isNaN(date.getTime())) {
                value = date.toISOString().split('T')[0];
              }
            }
          }

          // 特殊处理数值类型
          if (formKey === 'ratedLoad' && value) {
            // 确保额定载重量是数字
            value = typeof value === 'number' ? value : parseFloat(value) || value;
          }
          // 速度字段保留原始格式（如 0.50），避免 parseFloat 丢失尾部 0
          if ((formKey === 'ratedSpeed' || formKey === 'nominalSpeed') && value !== '' && value !== null && value !== undefined) {
            value = String(value);
          }
          if ((formKey === 'liftHeight' || formKey === 'sectionLength' || formKey === 'transportCapacity') && value !== '' && value !== null && value !== undefined) {
            const n = typeof value === 'number' ? value : parseFloat(value);
            value = Number.isNaN(n) ? value : n;
          }

          this.equipmentInfo[formKey] = value;
          console.log(`设备信息回填: ${apiKey} -> ${formKey} = ${value}`);
        }
      });

      // 兼容旧接口：仅有 RATEDLOAD、无 TRANSPORT_CAPACITY 时，历史上曾把 RATEDLOAD 当作输送能力使用
      // if (additionalData.TRANSPORT_CAPACITY === undefined && additionalData.RATEDLOAD !== undefined && additionalData.RATEDLOAD !== null && additionalData.RATEDLOAD !== '') {
      //   this.equipmentInfo.transportCapacity = additionalData.RATEDLOAD;
      //   this.equipmentInfo.ratedLoad = '';
      // }

      // 处理下次检测日期和下次检验日期
      // 仍按历史优先级取值，但不再拆分年月；且 '无' 也是有效值（直接使用，不再回退第二字段）
      const isValidNextDateValue = (v) => typeof v === 'string' && v !== '';

      if (isValidNextDateValue(additionalData.nextTestDate)) {
        this.equipmentInfo.nextTestDate = additionalData.nextTestDate;
        console.log('下次检测日期回填:', this.equipmentInfo.nextTestDate);
      } else if (isValidNextDateValue(additionalData.nextTestYearMonth)) {
        this.equipmentInfo.nextTestDate = additionalData.nextTestYearMonth;
        console.log('下次检测日期回填(YearMonth):', this.equipmentInfo.nextTestDate);
      }

      if (isValidNextDateValue(additionalData.nextCheckDate)) {
        this.equipmentInfo.nextCheckDate = additionalData.nextCheckDate;
        console.log('下次检验日期回填:', this.equipmentInfo.nextCheckDate);
      } else if (isValidNextDateValue(additionalData.nextRegularDate)) {
        this.equipmentInfo.nextCheckDate = additionalData.nextRegularDate;
        console.log('下次检验日期回填(RegularDate):', this.equipmentInfo.nextCheckDate);
      }

      // 特殊处理：层/站/门信息（支持 0；分项字段单独保存便于提交根字段）
      const eleF = additionalData.ELEFLOORNUMBER;
      const eleS = additionalData.ELESTADENUMBER;
      const eleD = additionalData.ELEDOORNUMBER;
      if (eleF !== undefined && eleF !== null && eleF !== '') {
        this.equipmentInfo.eleFloorNumber = eleF;
      }
      if (eleS !== undefined && eleS !== null && eleS !== '') {
        this.equipmentInfo.eleStadeNumber = eleS;
      }
      if (eleD !== undefined && eleD !== null && eleD !== '') {
        this.equipmentInfo.eleDoorNumber = eleD;
      }
      if (eleF != null || eleS != null || eleD != null) {
        const floorInfo = [];
        if (eleF != null && eleF !== '') floorInfo.push(`${eleF}层`);
        if (eleS != null && eleS !== '') floorInfo.push(`${eleS}站`);
        if (eleD != null && eleD !== '') floorInfo.push(`${eleD}门`);
        if (floorInfo.length) {
          this.equipmentInfo.floorStationDoor = floorInfo.join('/');
        }
      }

      // 与历史逻辑一致：EQP_USE_ADDR 曾覆盖 installLocation（用于 EQP_AREA_NAME 提交字段）
      if (additionalData.EQP_USE_ADDR !== undefined && additionalData.EQP_USE_ADDR !== null && additionalData.EQP_USE_ADDR !== '') {
        this.equipmentInfo.installLocation = additionalData.EQP_USE_ADDR;
      } else if (!String(this.equipmentInfo.installLocation || '').trim() && this.equipmentInfo.eqpUseAddr) {
        this.equipmentInfo.installLocation = this.equipmentInfo.eqpUseAddr;
      }

      // 反填检测人员和校核人员
      if (additionalData.testEmployeePid) {
        this.equipmentInfo.detectionPersonnel = additionalData.testEmployeePid;
        console.log('检测人员回填:', additionalData.testEmployeePid);
      }

      // 校核人员：如果有值就用自己的，如果为空就用检测人员的值
      if (additionalData.checkEmployeePid) {
        this.equipmentInfo.reviewPersonnel = additionalData.checkEmployeePid;
        console.log('校核人员回填:', additionalData.checkEmployeePid);
      } else if (additionalData.testEmployeePid) {
        this.equipmentInfo.reviewPersonnel = additionalData.testEmployeePid;
        console.log('校核人员为空，使用检测人员填充:', additionalData.testEmployeePid);
      }

      // 反填检测问题汇总和备注
      if (additionalData.testConclusion) {
        this.equipmentInfo.problemSummary = additionalData.testConclusion.replace(/\\n/g, '\n');
        console.log('检测问题汇总回填:', additionalData.testConclusion);
      }
      if (additionalData.testConclusionDesc) {
        this.equipmentInfo.remarks = additionalData.testConclusionDesc.replace(/\\n/g, '\n');
        console.log('备注回填:', additionalData.testConclusionDesc);
      }

      // 反填检测日期
      if (additionalData.testEmployeeDate) {
        this.equipmentInfo.detectionDate = additionalData.testEmployeeDate;
        console.log('检测日期回填:', additionalData.testEmployeeDate);
      }
    },

    // 反填封面信息
    fillCoverInfo (additionalData) {
      // 封面信息字段映射
      const coverMapping = {
        'USE_UNT_NAME': 'useUnitName', // 使用单位
        'recordNum': 'recordNum', // 记录编号
        'testEmployeeDate': 'testDate', // 检测日期 - 从testEmployeeDate字段获取
        'EQP_VART_NAME': 'EQP_VART_NAME', // 原始记录名称
        'EQP_SORT_NAME': 'EQP_SORT_NAME', // 设备类别
      };

      // 遍历映射关系，将数据填入对应字段
      Object.keys(coverMapping).forEach(apiKey => {
        if (additionalData[apiKey] !== undefined) {
          const formKey = coverMapping[apiKey];
          let value = additionalData[apiKey];

          // 特殊处理日期格式
          if (formKey === 'testDate' && value) {
            // 确保日期格式正确，如果是 YYYY-MM-DD 格式则保持不变
            if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
              value = value;
            } else {
              // 尝试格式化日期
              const date = new Date(value);
              if (!isNaN(date.getTime())) {
                value = date.toISOString().split('T')[0];
              }
            }
          }

          this.coverInfo[formKey] = value;
          console.log(`封面信息回填: ${apiKey} -> ${formKey} = ${value}`);
          if (formKey === 'EQP_SORT_NAME') {
            this.equipmentInfo.eqpSortName = value;
          }
        }
      });

      // 设备代码可能来自多个字段
      if (additionalData.EQP_STATION_COD) {
        this.coverInfo.EQP_STATION_COD = additionalData.EQP_STATION_COD;
      }
    },

    // 反填设备仪器数据
    fillInstrumentData (additionalData) {
      // 首先尝试从datas数组中获取设备相关数据
      const equipmentDataFromDatas = {};
      if (additionalData.datas && Array.isArray(additionalData.datas)) {
        additionalData.datas.forEach(item => {
          if (item.dataKey && (item.dataKey.startsWith('EquipmentName') || item.dataKey.startsWith('MgmtNo') || item.dataKey.startsWith('V'))) {
            equipmentDataFromDatas[item.dataKey] = item.dataValue;
          }
        });
      }

      // 设备名称字段映射
      const equipmentNameMapping = [
        'EquipmentName01', 'EquipmentName02', 'EquipmentName03', 'EquipmentName04', 'EquipmentName05',
        'EquipmentName06', 'EquipmentName07', 'EquipmentName08', 'EquipmentName09', 'EquipmentName10',
        'EquipmentName11', 'EquipmentName12', 'EquipmentName13', 'EquipmentName14', 'EquipmentName15',
        'EquipmentName16', 'EquipmentName17', 'EquipmentName18', 'EquipmentName19', 'EquipmentName20'
      ];

      // 管理编号字段映射
      const managementNumberMapping = [
        'MgmtNo01', 'MgmtNo02', 'MgmtNo03', 'MgmtNo04', 'MgmtNo05',
        'MgmtNo06', 'MgmtNo07', 'MgmtNo08', 'MgmtNo09', 'MgmtNo10',
        'MgmtNo11', 'MgmtNo12', 'MgmtNo13', 'MgmtNo14', 'MgmtNo15',
        'MgmtNo16', 'MgmtNo17', 'MgmtNo18', 'MgmtNo19', 'MgmtNo20'
      ];

      // 使用记录字段映射
      const usageRecordMapping = [
        'V01', 'V02', 'V03', 'V04', 'V05',
        'V06', 'V07', 'V08', 'V09', 'V10',
        'V11', 'V12', 'V13', 'V14', 'V15',
        'V16', 'V17', 'V18', 'V19', 'V20'
      ];

      // 反填设备名称、管理编号和使用记录
      for (let i = 0; i < 10; i++) {
        // 第一列设备（name, managementNumber, usageRecord）
        const equipmentData1 = equipmentDataFromDatas[equipmentNameMapping[i]];

        if (equipmentData1) {
          // 如果dataValue是对象(新格式),包含name、managementNumber、usageRecord
          if (typeof equipmentData1 === 'object' && equipmentData1.name) {
            this.instrumentTableData[i].name = this.getEquipmentIdByName(equipmentData1.name);
            this.instrumentTableData[i].managementNumber = equipmentData1.managementNumber || '';
            this.instrumentTableData[i].usageRecord = equipmentData1.usageRecord || '';
          }
          // 如果dataValue是字符串(旧格式),只有设备名称
          else if (typeof equipmentData1 === 'string') {
            this.instrumentTableData[i].name = this.getEquipmentIdByName(equipmentData1);
            // 从对应的管理编号和使用记录字段获取数据
            this.instrumentTableData[i].managementNumber = equipmentDataFromDatas[managementNumberMapping[i]] || additionalData[managementNumberMapping[i]] || '';
            this.instrumentTableData[i].usageRecord = equipmentDataFromDatas[usageRecordMapping[i]] || '';
          }
        }
        // 如果datas中没有,尝试从外层获取(向后兼容)
        else if (additionalData[equipmentNameMapping[i]]) {
          this.instrumentTableData[i].name = this.getEquipmentIdByName(additionalData[equipmentNameMapping[i]]);
          this.instrumentTableData[i].managementNumber = additionalData[managementNumberMapping[i]] || '';
        }

        // 第二列设备（name2, managementNumber2, usageRecord2）
        const equipmentData2 = equipmentDataFromDatas[equipmentNameMapping[i + 10]];

        if (equipmentData2) {
          // 如果dataValue是对象(新格式),包含name、managementNumber、usageRecord
          if (typeof equipmentData2 === 'object' && equipmentData2.name) {
            this.instrumentTableData[i].name2 = this.getEquipmentIdByName(equipmentData2.name);
            this.instrumentTableData[i].managementNumber2 = equipmentData2.managementNumber || '';
            this.instrumentTableData[i].usageRecord2 = equipmentData2.usageRecord || '';
          }
          // 如果dataValue是字符串(旧格式),只有设备名称
          else if (typeof equipmentData2 === 'string') {
            this.instrumentTableData[i].name2 = this.getEquipmentIdByName(equipmentData2);
            // 从对应的管理编号和使用记录字段获取数据
            this.instrumentTableData[i].managementNumber2 = equipmentDataFromDatas[managementNumberMapping[i + 10]] || additionalData[managementNumberMapping[i + 10]] || '';
            this.instrumentTableData[i].usageRecord2 = equipmentDataFromDatas[usageRecordMapping[i + 10]] || '';
          }
        }
        // 如果datas中没有,尝试从外层获取(向后兼容)
        else if (additionalData[equipmentNameMapping[i + 10]]) {
          this.instrumentTableData[i].name2 = this.getEquipmentIdByName(additionalData[equipmentNameMapping[i + 10]]);
          this.instrumentTableData[i].managementNumber2 = additionalData[managementNumberMapping[i + 10]] || '';
        }
      }

      console.log('设备仪器数据回填完成');
    },

    // 处理原有格式的数据（兼容性）
    fillLegacyData (datas) {
      // 若设备为杂物电梯模板，全部默认符合，不做强制无此项
      const forceNotApplicableEquipmentNames = [];

      // 遍历返回的数据，根据dataKey反填到对应的字段
      datas.forEach(item => {
        const { dataKey, dataValue } = item;

        // 反填第一页检验结果数据
        if (this.isPageOneDataKey(dataKey)) {
          const cleanDataKey = dataKey.startsWith('*') ? dataKey.substring(1) : dataKey;
          let valueToFill = dataValue;
          if (cleanDataKey === 'A1.3.12.1' && forceNotApplicableEquipmentNames.includes(this.recordInfo?.equipmentName)) {
            valueToFill = '无此项';
          }
          this.fillPageOneData(dataKey, valueToFill);
        }

        // 反填第二页表格数据
        if (this.isPageTwoDataKey(dataKey)) {
          this.fillPageTwoData(dataKey, dataValue);
        }

        // 反填其他字段（如人员、日期等）
        this.fillOtherFields(dataKey, dataValue);
      });
    },

    // 反填详情数据
    fillDetailData (datas) {
      if (!datas || !Array.isArray(datas)) {
        return;
      }

      // 遍历datas，查找所有详情数据（dataKey为itemNumber格式的）
      datas.forEach(item => {
        if (item.dataKey && item.dataValue) {
          try {
            const parsedData = JSON.parse(item.dataValue);
            if (Array.isArray(parsedData) && parsedData.length > 0) {
              // 找到对应的树节点
              const treeNode = this.findTreeNodeByItemNumber(item.dataKey);
              if (treeNode) {
                // 存储到additionalDataList中，以便后续恢复
                if (!this.additionalDataList) {
                  this.additionalDataList = {};
                }
                if (!this.additionalDataList.datas) {
                  this.additionalDataList.datas = [];
                }

                // 检查是否已存在
                const existingIndex = this.additionalDataList.datas.findIndex(d => d.dataKey === item.dataKey);
                if (existingIndex >= 0) {
                  this.additionalDataList.datas[existingIndex] = item;
                } else {
                  this.additionalDataList.datas.push(item);
                }
              }
            }
          } catch (e) {
            // 如果不是JSON格式，忽略
            console.log('dataKey:', item.dataKey, '不是JSON格式，跳过');
          }
        }
      });
    },

    // 根据itemNumber查找树节点
    findTreeNodeByItemNumber (itemNumber) {
      // 递归查找树节点
      const findInTree = (nodes) => {
        for (const node of nodes) {
          if (node.itemNumber === itemNumber) {
            return node;
          }
          if (node.children && node.children.length > 0) {
            const found = findInTree(node.children);
            if (found) return found;
          }
        }
        return null;
      };

      return findInTree(this.pageOneTreeData);
    },

    // 判断是否为第一页数据
    isPageOneDataKey (dataKey) {
      // 第一页的dataKey通常是检验项目编号，如 A1.1.1.1, A1.2.1.1 等
      // 关键检测项目以*开头，如 *A1.2.2.4
      return /^(\*)?A\d+\.\d+(\.\d+)*(\.\d+)?$/.test(dataKey);
    },

    // 判断是否为第二页数据
    isPageTwoDataKey (dataKey) {
      return isGoodsElevatorPageTwoDataKey(dataKey);
    },

    // 反填第一页数据
    fillPageOneData (dataKey, dataValue) {
      // 去掉关键检测项目的*前缀来查找对应项目
      const cleanDataKey = dataKey.startsWith('*') ? dataKey.substring(1) : dataKey;

      // 在pageOneData中查找对应的项目并设置result或autoResult
      const item = this.pageOneData.find(item => item.itemNumber === cleanDataKey);
      if (!item) {
        const treeNode = this.findTreeNodeByItemNumber(this.pageOneTreeData, cleanDataKey);
        if (treeNode && treeNode.level === 2 && treeNode.children) {
          if (dataValue === '符合') {
            treeNode.autoResult = 'qualified';
          } else if (dataValue === '无此项') {
            treeNode.autoResult = 'notApplicable';
          } else {
            treeNode.autoResult = 'unqualified';
          }
        }
        return;
      }

      let resultValue = '';
      if (item.level === 3) {
        // 子项设置检验结果
        // 根据dataValue设置对应状态：符合、不符合、无此项，其他值默认为不符合
        if (dataValue === '符合') {
          resultValue = 'qualified';
        } else if (dataValue === '无此项') {
          resultValue = 'notApplicable';
        } else if (dataValue === '不符合') {
          resultValue = 'unqualified';
        } else {
          // 其他任何值都默认为不符合
          resultValue = 'unqualified';
          // 如果dataValue不是标准值，可以存储到备注中
          if (dataValue && dataValue !== '不合格') {
            console.log(`检测项目 ${cleanDataKey} 的具体问题: ${dataValue}`);
          }
        }
        item.result = resultValue;

        // 同步更新pageOneTreeData中的数据，防止flattenTreeData时数据丢失
        this.updateTreeNodeResult(item.id, resultValue);

        // 设置子项结果后，需要更新父项的综合检验结果
        this.updateParentAutoResult(item);
      } else if (item.hasChildren) {
        // 父项设置综合检验结果
        if (dataValue === '符合') {
          item.autoResult = 'qualified';
        } else if (dataValue === '无此项') {
          item.autoResult = 'notApplicable';
        } else {
          item.autoResult = 'unqualified';
        }
      }
    },

    // 更新树形数据中节点的result值（不触发flattenTreeData）
    updateTreeNodeResult (id, result) {
      const updateNode = (nodes) => {
        for (let node of nodes) {
          if (node.id === id) {
            node.result = result;
            return true;
          }
          if (node.children && updateNode(node.children)) {
            return true;
          }
        }
        return false;
      };
      updateNode(this.pageOneTreeData);
    },

    // 反填第二页数据
    fillPageTwoData (dataKey, dataValue) {
      if (dataKey.startsWith('CheckFloor')) {
        const floorNum = parseInt(dataKey.replace('CheckFloor', ''), 10);
        const tableId = `table${floorNum}`;
        const tableConfig = this.goodsElevatorTables[tableId];
        if (tableConfig && dataValue) {
          const doorNos = String(dataValue).split(/[/、,，]/).map(s => s.trim()).filter(Boolean);
          doorNos.forEach((doorNo, index) => {
            if (index < tableConfig.columnCount && tableConfig.columns[index]) {
              this.setGoodsElevatorCellValueOnTable(tableId, index, 'doorNo', doorNo);
            }
          });
        }
        return;
      }

      for (const tableId of Object.keys(this.goodsElevatorTables)) {
        const tableConfig = this.goodsElevatorTables[tableId];
        const resolved = resolveGoodsElevatorTableCell(tableConfig, dataKey);
        if (!resolved) continue;
        const normalized = dataValue == null ? '' : String(dataValue);
        this.setGoodsElevatorCellValueOnTable(tableId, resolved.colIndex, resolved.rowKey, normalized);
        return;
      }
    },

    setGoodsElevatorCellValueOnTable (tableId, colIndex, rowKey, value) {
      const cfg = this.goodsElevatorTables[tableId];
      if (!cfg || !cfg.columns[colIndex]) return;
      if (!cfg.columns[colIndex].values) {
        this.$set(cfg.columns[colIndex], 'values', {});
      }
      this.$set(cfg.columns[colIndex].values, rowKey, value == null ? '' : value);
    },

    // 反填其他字段
    fillOtherFields (dataKey, dataValue) {
      // 处理检测环境条件确认结果 Result01-07（1-7条独立）
      if (dataKey === 'Result01') {
        if (this.environmentConditionsData[0]) {
          this.environmentConditionsData[0].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result02') {
        if (this.environmentConditionsData[1]) {
          this.environmentConditionsData[1].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result03') {
        if (this.environmentConditionsData[2]) {
          this.environmentConditionsData[2].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result04') {
        if (this.environmentConditionsData[3]) {
          this.environmentConditionsData[3].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result05') {
        if (this.environmentConditionsData[4]) {
          this.environmentConditionsData[4].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result06') {
        if (this.environmentConditionsData[5]) {
          this.environmentConditionsData[5].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result07') {
        if (this.environmentConditionsData[6]) {
          this.environmentConditionsData[6].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result08') {
        if (this.environmentConditionsData[7]) {
          this.environmentConditionsData[7].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'LegacyResult01') {
        // 兼容历史：旧版「第1-5条合并结果」不再使用，保留占位避免误处理
        if (this.environmentConditionsData[0] && !this.environmentConditionsData[0].confirmResult) {
          this.environmentConditionsData[0].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      }
      // 其他特殊字段可以继续在这里添加
    },

    // 环境条件确认表格单元格合并方法
    environmentConditionsSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 检测环境条件不再做任何行合并，所有单元格都独立显示
      return { rowspan: 1, colspan: 1 };
    },

    // 统计一级节点下二级子节点数量
    getLevel2ChildrenCount (level1Node) {
      if (!level1Node || !Array.isArray(level1Node.children)) {
        return 0;
      }
      return level1Node.children.filter(child => child.level === 2).length;
    },

    // 一级下仅有一个二级时，该二级不在表格展示（仍保留在树中参与汇总与提交）
    shouldHideLevel2InTable (level1Node) {
      return this.getLevel2ChildrenCount(level1Node) === 1;
    },

    // 将树形数据转换为平层数据用于表格显示
    flattenTreeData () {
      const result = [];
      const usedIds = new Set(); // 用于检测重复ID

      const flatten = (nodes, parentNode = null, topLevelId = '') => {
        nodes.forEach((node, index) => {
          // 确保ID唯一
          let uniqueId = node.id;
          if (usedIds.has(uniqueId)) {
            uniqueId = `${node.id}-${Date.now()}-${index}`;
          }
          usedIds.add(uniqueId);

          const currentTopLevelId = node.level === 1 ? node.id : topLevelId;

          // 一级下仅有一个二级时隐藏该二级；多个二级时正常展示
          const skipLevel2InTable = node.level === 2
            && parentNode
            && parentNode.level === 1
            && this.shouldHideLevel2InTable(parentNode);

          if (!skipLevel2InTable) {
            const flatItem = {
              id: uniqueId,
              originalId: node.id, // 保留原始ID用于逻辑处理
              itemNumber: node.itemNumber,
              description: node.description,
              level: node.level,
              topLevelId: currentTopLevelId, // 所属一级父节点分组ID（用于分组样式）
              hasOpenedResultDialog: !!node.hasOpenedResultDialog,
              result: node.result || '',
              hasChildren: node.children && node.children.length > 0,
              autoResult: node.autoResult || null,
              attachmentTable: node.attachmentTable || null // 附表配置
            };

            result.push(flatItem);
          }

          // 递归处理子节点（含被隐藏的二级）
          if (node.children && node.children.length > 0) {
            flatten(node.children, node, currentTopLevelId);
          }
        });
      };

      flatten(this.pageOneTreeData);

      // 使用 Vue.set 确保响应式更新
      this.$set(this, 'pageOneData', result);
    },

    // 根据ID更新树形数据中的结果
    updateTreeDataResult (id, result) {
      const updateNode = (nodes) => {
        for (let node of nodes) {
          if (node.id === id) {
            node.result = result;
            return true;
          }
          if (node.children && updateNode(node.children)) {
            return true;
          }
        }
        return false;
      };

      updateNode(this.pageOneTreeData);

      // 更新平铺数据
      this.flattenTreeData();

      // 更新父级的自动检验结果
      const item = this.findItemById(this.pageOneData, id);
      if (item) {
        this.updateParentAutoResult(item);
      }
    },

    // 生成动态编号
    generateDynamicNumbers (data) {
      const numberCount = {};

      // 统计每个基础编号下的数据数量
      data.forEach(item => {
        if (item.level === 3) {
          // 获取基础编号（去掉最后的-x部分）
          const baseNumber = item.id.replace(/-\d+$/, '');
          if (!numberCount[baseNumber]) {
            numberCount[baseNumber] = [];
          }
          numberCount[baseNumber].push(item);
        }
      });

      // 为每个基础编号分配具体编号
      Object.keys(numberCount).forEach(baseNumber => {
        const items = numberCount[baseNumber];
        // 无论有几个子项，都给每个子项分配独立的编号
        items.forEach((item, index) => {
          const itemNumber = `${baseNumber}.${index + 1}`;
          item.itemNumber = itemNumber;
          item.dataKey = itemNumber;
        });
      });

      return data;
    },

    // 查找数据项
    findItemById (data, id) {
      for (let item of data) {
        if (item.id === id) {
          return item;
        }
      }
      return null;
    },

    // 更新父级自动检验结果 - 支持三级联动
    updateParentAutoResult (changedItem) {
      // level 3 变更：先更新树中的 level 2，再更新表格中的 level 1
      if (changedItem.level === 3) {
        const level2ParentId = changedItem.id.replace(/-\d+$/, '');
        const level2Parent = this.findOriginalItem(this.pageOneTreeData, level2ParentId);
        if (level2Parent && level2Parent.children && level2Parent.children.length > 0) {
          this.updateItemAutoResult(level2Parent);

          const level1Parent = this.findParentItem(this.pageOneData, { id: level2ParentId, level: 2 });
          if (level1Parent && level1Parent.hasChildren && level1Parent.level === 1) {
            this.updateItemAutoResult(level1Parent);
          }
        }
      }
      // 如果传入的是 level 1 项目，直接更新它的 autoResult
      else if (changedItem.level === 1 && changedItem.hasChildren) {
        this.updateItemAutoResult(changedItem);
      }
    },

    // 更新单个项目的自动检验结果
    updateItemAutoResult (item) {
      const childResults = this.getChildrenResults(item);

      // 计算自动检验结果：
      // 1. 如果所有子项都是"无此项"，则父项也是"无此项"
      // 2. 如果有"无此项"也有其他结果，"无此项"不参与计算
      // 3. 只要有一个"不符合"就是"不符合"
      // 4. 全部"符合"才是"符合"

      if (childResults.length === 0) {
        item.autoResult = null;
      } else {
        // 过滤掉"无此项"的结果
        const effectiveResults = childResults.filter(result => result !== 'notApplicable');
        const notApplicableCount = childResults.filter(result => result === 'notApplicable').length;

        if (effectiveResults.length === 0 && notApplicableCount > 0) {
          // 所有子项都是"无此项"
          item.autoResult = 'notApplicable';
        } else if (effectiveResults.some(result => result === 'unqualified')) {
          // 有效结果中有"不符合"
          item.autoResult = 'unqualified';
        } else if (effectiveResults.every(result => result === 'qualified')) {
          // 有效结果全部是"符合"
          item.autoResult = 'qualified';
        } else {
          // 还有未检验的项目
          item.autoResult = null;
        }
      }

      // 同步更新树形数据中的autoResult
      const updateTreeAutoResult = (nodes) => {
        for (let node of nodes) {
          if (node.id === item.id) {
            node.autoResult = item.autoResult;
            return true;
          }
          if (node.children && updateTreeAutoResult(node.children)) {
            return true;
          }
        }
        return false;
      };
      updateTreeAutoResult(this.pageOneTreeData);
    },

    // 查找父级项目
    findParentItem (data, targetItem) {
      // 根据ID规律找父级：
      // A1.2.1.1-1 (level 3) 的父级是 A1.2.1.1 (level 2)
      // A1.2.1.1 (level 2) 的父级是 A1.2.1 (level 1)
      const targetId = targetItem.id;
      let parentId = '';

      if (targetId.includes('-')) {
        // 如果是 level 3 子项（包含-），父级是去掉-x部分
        parentId = targetId.replace(/-\d+$/, '');
      } else if (targetItem.level === 2) {
        // 如果是 level 2 项（如 A1.2.1.1），父级是去掉最后一个点及之后的部分（A1.2.1）
        const parts = targetId.split('.');
        if (parts.length > 1) {
          parts.pop(); // 移除最后一部分
          parentId = parts.join('.');
        }
      }

      if (parentId) {
        return this.findItemById(data, parentId);
      }

      return null;
    },

    // 获取子项检验结果 - 支持三级联动
    getChildrenResults (parentItem) {
      const results = [];
      const parentId = parentItem.id;
      const parentLevel = parentItem.level;

      if (parentLevel === 1) {
        const level1TreeNode = this.findOriginalItem(this.pageOneTreeData, parentId);
        if (level1TreeNode && this.shouldHideLevel2InTable(level1TreeNode)) {
          // 单个二级被隐藏：一级综合结果直接汇总其下所有 level 3
          const childItems = this.pageOneData.filter(item =>
            item.level === 3 && item.id.startsWith(parentId + '.')
          );
          childItems.forEach(item => {
            if (item.result) {
              results.push(item.result);
            }
          });
        } else if (level1TreeNode && Array.isArray(level1TreeNode.children)) {
          // 多个二级在表格展示：汇总各二级的 autoResult
          level1TreeNode.children
            .filter(child => child.level === 2)
            .forEach(level2Node => {
              if (level2Node.autoResult) {
                results.push(level2Node.autoResult);
              }
            });
        }
      } else if (parentLevel === 2) {
        // level 2 的父项，查找直接的 level 3 子项
        const childItems = this.pageOneData.filter(item =>
          item.level === 3 && item.id.startsWith(parentId + '-')
        );

        childItems.forEach(item => {
          if (item.result) {
            results.push(item.result);
          }
        });
      }

      return results;
    },

    // 初始化数据结构
    initializePageOneData () {
      // 先平铺数据
      this.flattenTreeData();

      // 为数据添加必要的属性
      this.pageOneData.forEach(item => {
        // 判断是否有子项 - 修复逻辑：检查原始树形数据中是否有children
        item.hasChildren = false;
        if (item.level < 3) {
          // 在原始树形数据中查找对应项目
          const originalItem = this.findOriginalItem(this.pageOneTreeData, item.id);
          if (originalItem && originalItem.children && originalItem.children.length > 0) {
            item.hasChildren = true;
          }
        }

        // 初始化自动检验结果（level 1 和 level 2 都参与）
        if (item.hasChildren && (item.level === 1 || item.level === 2)) {
          item.autoResult = null;
        }
      });

      // 编号已在数据文件中固定，无需动态生成

      // 初始化所有父级的综合检验结果
      this.initializeAllParentAutoResults();

      // 生成导航列表
      this.generateNavigationList();

      // 确保表格滚动条可见
      this.ensureTableScrollable();

      // 强制刷新表格视图 - 使用多种方式确保更新
      this.$nextTick(() => {
        // 方法1: 强制Vue重新渲染
        this.$forceUpdate();

        // 方法2: 刷新表格布局
        if (this.$refs.pageOneTable) {
          this.$refs.pageOneTable.doLayout();
        }

        // 方法3: 再次在下一个tick强制更新
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      });
    },

    // 初始化所有父级的综合检验结果
    initializeAllParentAutoResults () {
      // 从level 3的项目开始，向上更新所有父级
      const level3Items = this.pageOneData.filter(item => item.level === 3);

      // 收集所有需要更新的 level 2 父级ID（避免重复更新）
      const level2ParentIds = new Set();
      const level1ParentIds = new Set();

      level3Items.forEach(item => {
        const level2ParentId = item.id.replace(/-\d+$/, '');
        if (level2ParentId) {
          level2ParentIds.add(level2ParentId);

          const parts = level2ParentId.split('.');
          if (parts.length > 1) {
            parts.pop();
            level1ParentIds.add(parts.join('.'));
          }
        }
      });

      // 先更新树中所有 level 2 父级的综合检验结果
      level2ParentIds.forEach(parentId => {
        const treeNode = this.findOriginalItem(this.pageOneTreeData, parentId);
        if (treeNode) {
          this.updateItemAutoResult(treeNode);
        }
      });

      // 再更新所有 level 1 父级的综合检验结果
      level1ParentIds.forEach(parentId => {
        const parentItem = this.findItemById(this.pageOneData, parentId);
        if (parentItem) {
          this.updateItemAutoResult(parentItem);
        }
      });
    },

    // 在原始树形数据中查找项目
    findOriginalItem (treeData, targetId) {
      for (let item of treeData) {
        if (item.id === targetId) {
          return item;
        }
        if (item.children) {
          const found = this.findOriginalItem(item.children, targetId);
          if (found) return found;
        }
      }
      return null;
    },

    // 在树形数据中按 itemNumber 查找节点（用于隐藏二级的回填）
    findTreeNodeByItemNumber (treeData, itemNumber) {
      for (const item of treeData) {
        if (item.itemNumber === itemNumber) {
          return item;
        }
        if (item.children) {
          const found = this.findTreeNodeByItemNumber(item.children, itemNumber);
          if (found) return found;
        }
      }
      return null;
    },

    // 生成导航列表：一级始终显示；一级下仅一个二级时不显示二级，多个二级时显示
    generateNavigationList () {
      this.navigationList = [];

      this.pageOneTreeData.forEach(level1Item => {
        if (!level1Item.itemNumber) {
          return;
        }

        this.navigationList.push({
          id: level1Item.id,
          itemNumber: level1Item.itemNumber,
          description: this.truncateDescription(level1Item.description, 15),
          level: 1
        });

        if (!this.shouldHideLevel2InTable(level1Item) && Array.isArray(level1Item.children)) {
          level1Item.children
            .filter(child => child.level === 2 && child.itemNumber)
            .forEach(level2Item => {
              this.navigationList.push({
                id: level2Item.id,
                itemNumber: level2Item.itemNumber,
                description: this.truncateDescription(level2Item.description, 15),
                level: 2
              });
            });
        }
      });

      console.log('生成的导航列表:', this.navigationList);
      console.log('表格数据:', this.pageOneData);
    },

    // 截断描述文本
    truncateDescription (text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    // 滚动到指定项目
    scrollToItem (itemId) {
      this.activeNavId = itemId;
      console.log('点击导航项:', itemId);

      // 在表格数据中找到对应的行索引
      const targetIndex = this.pageOneData.findIndex(item => item.id === itemId);
      console.log('找到目标行索引:', targetIndex);

      if (targetIndex !== -1) {
        this.$nextTick(() => {
          const table = this.$refs.pageOneTable;
          if (table && table.$el) {
            // 获取表格的滚动容器
            const scrollContainer = table.$el.querySelector('.el-table__body-wrapper');
            // 获取目标行的DOM元素
            const rows = table.$el.querySelectorAll('.el-table__row');
            const targetRow = rows[targetIndex];

            console.log('找到的目标行:', targetRow);
            console.log('滚动容器:', scrollContainer);

            if (targetRow && scrollContainer) {
              // 获取目标行相对于表格body的偏移位置
              const targetOffsetTop = targetRow.offsetTop;

              // 只滚动表格内部的容器，不影响整个页面
              scrollContainer.scrollTo({
                top: targetOffsetTop - 10, // 减去10px，让目标行有一点间距
                behavior: 'smooth'
              });
              console.log('滚动到位置:', targetOffsetTop);
            } else {
              // 备用方案：使用原来的计算方式
              let bodyWrapper = table.$el.querySelector('.el-table__body-wrapper');
              if (!bodyWrapper) {
                bodyWrapper = table.$el.querySelector('.el-table__body');
              }
              if (!bodyWrapper) {
                bodyWrapper = table.$el.querySelector('.el-scrollbar__wrap');
              }

              console.log('找到的滚动容器:', bodyWrapper);

              if (bodyWrapper && rows.length > 0) {
                // 获取表格行的实际高度
                let rowHeight = rows[0].offsetHeight || 80;

                // 计算目标行的位置，滚动到顶部
                const scrollTop = Math.max(0, targetIndex * rowHeight);

                console.log('滚动前容器状态:', {
                  scrollHeight: bodyWrapper.scrollHeight,
                  clientHeight: bodyWrapper.clientHeight,
                  currentScrollTop: bodyWrapper.scrollTop,
                  targetScrollTop: scrollTop
                });

                // 尝试多种滚动方式
                try {
                  // 方式1：使用Element UI的setScrollTop方法
                  if (table.setScrollTop && typeof table.setScrollTop === 'function') {
                    table.setScrollTop(scrollTop);
                    console.log('使用Element UI setScrollTop方法');
                  }
                  // 方式2：使用scrollTo方法
                  else if (bodyWrapper.scrollTo) {
                    bodyWrapper.scrollTo({
                      top: scrollTop,
                      behavior: 'smooth'
                    });
                    console.log('使用scrollTo方法');
                  }
                  // 方式3：直接设置scrollTop
                  else {
                    bodyWrapper.scrollTop = scrollTop;
                    console.log('使用直接设置scrollTop方法');
                  }
                } catch (error) {
                  console.error('滚动失败:', error);
                  // 最后的备用方案
                  bodyWrapper.scrollTop = scrollTop;
                }

                console.log('滚动到位置:', scrollTop, '行高:', rowHeight);
              }
            }

            // 延迟高亮显示目标行
            setTimeout(() => {
              this.highlightTargetRow(itemId, targetIndex);
            }, 300);
          } else {
            console.error('未找到表格或表格元素');
          }
        });
      } else {
        console.error('未找到目标行');
      }
    },

    // 高亮目标行
    highlightTargetRow (itemId, targetIndex) {
      // 移除之前的高亮
      const previousHighlight = document.querySelector('.highlight-row');
      if (previousHighlight) {
        previousHighlight.classList.remove('highlight-row');
      }

      // 添加新的高亮
      setTimeout(() => {
        const table = this.$refs.pageOneTable;
        if (table && table.$el) {
          // 尝试多种方式找到目标行
          let targetRow = null;

          // 方法1：通过row-key查找
          targetRow = table.$el.querySelector(`[data-row-key="${itemId}"]`);

          // 方法2：通过行索引查找
          if (!targetRow && typeof targetIndex === 'number') {
            const rows = table.$el.querySelectorAll('.el-table__row');
            if (rows[targetIndex]) {
              targetRow = rows[targetIndex];
            }
          }

          // 方法3：通过CSS类查找
          if (!targetRow) {
            targetRow = table.$el.querySelector(`.row-${itemId}`);
          }

          if (targetRow) {
            targetRow.classList.add('highlight-row');
            // 3秒后移除高亮
            setTimeout(() => {
              targetRow.classList.remove('highlight-row');
            }, 3000);
          } else {
            console.log('未找到目标行:', itemId, targetIndex);
          }
        }
      }, 200);
    },

    // 获取表格行的CSS类名
    getRowClassName ({ row, rowIndex }) {
      // const classNames = [`row-${row.id}`];
      const classNames = [`row-${row.id}`, `row-level-${row.level}`];
      const prevRow = this.pageOneData[rowIndex - 1];
      const nextRow = this.pageOneData[rowIndex + 1];

      if (!prevRow || prevRow.topLevelId !== row.topLevelId) {
        classNames.push('group-start-row');
      }
      if (!nextRow || nextRow.topLevelId !== row.topLevelId) {
        classNames.push('group-end-row');
      }

      if (row.level === 3) {
        const parentId = row.id.replace(/-\d+$/, '');
        const prevParentId = prevRow && prevRow.level === 3 ? prevRow.id.replace(/-\d+$/, '') : null;
        const nextParentId = nextRow && nextRow.level === 3 ? nextRow.id.replace(/-\d+$/, '') : null;

        if (!prevRow || prevRow.level !== 3 || prevParentId !== parentId) {
          classNames.push('level-3-group-start-row');
        }
        if (!nextRow || nextRow.level !== 3 || nextParentId !== parentId) {
          classNames.push('level-3-group-end-row');
        }
      }

      return classNames.join(' ');
    },

    // 确保表格可滚动
    ensureTableScrollable () {
      this.$nextTick(() => {
        const table = this.$refs.pageOneTable;
        if (table && table.$el) {
          const bodyWrapper = table.$el.querySelector('.el-table__body-wrapper');
          if (bodyWrapper) {
            // 强制设置滚动属性
            bodyWrapper.style.overflowY = 'auto';

            console.log('表格滚动设置完成:', {
              scrollHeight: bodyWrapper.scrollHeight,
              clientHeight: bodyWrapper.clientHeight,
              overflowY: bodyWrapper.style.overflowY
            });
          }
        }
      });
    },

    // 第一页表格单元格合并方法
    pageOneTableSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 只对综合检验结果列（第3列，columnIndex = 2）进行合并
      if (columnIndex === 2) {
        // 如果当前行有子项，需要计算合并的行数
        if (row.hasChildren) {
          // 计算从当前行开始，有多少个连续的子项
          let spanCount = 1;
          for (let i = rowIndex + 1; i < this.pageOneData.length; i++) {
            const nextRow = this.pageOneData[i];
            // 如果下一行是当前行的子项（level=3且id以当前行id开头）
            if (nextRow.level === 3 && nextRow.id.startsWith(row.id + '-')) {
              spanCount++;
            } else {
              break;
            }
          }
          return {
            rowspan: spanCount,
            colspan: 1
          };
        } else if (row.level === 3) {
          // 如果是子项，检查是否是父项的第一个子项
          const parentId = row.id.replace(/-\d+$/, '');
          const parentIndex = this.pageOneData.findIndex(item => item.id === parentId);
          if (parentIndex !== -1 && parentIndex < rowIndex) {
            // 不是第一个子项，隐藏单元格
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
      // 其他列不合并
      return {
        rowspan: 1,
        colspan: 1
      };
    },

    // 保存数据为指定格式
    savePageOneData () {
      const datas = [];

      // 将result值转换为中文
      const convertResultToText = (result) => {
        if (result === 'qualified') return '符合';
        if (result === 'notApplicable') return '无此项';
        return '不符合';
      };

      this.pageOneData.forEach(item => {
        // 保存子项的检验结果（level === 3 且有result的项目）
        if (item.level === 3 && item.result && item.itemNumber) {
          datas.push({
            dataKey: item.itemNumber,
            dataValue: convertResultToText(item.result)
          });
        }

        // 保存一级综合检验结果
        if (item.hasChildren && item.autoResult && item.itemNumber && item.level === 1) {
          datas.push({
            dataKey: item.itemNumber,
            dataValue: convertResultToText(item.autoResult)
          });
        }
      });

      // 未在表格展示的二级（一级下仅一个二级时隐藏），仍从树中提交综合检验结果
      const collectLevel2AutoResults = (nodes) => {
        nodes.forEach(node => {
          if (node.level === 2 && node.autoResult && node.itemNumber) {
            datas.push({
              dataKey: node.itemNumber,
              dataValue: convertResultToText(node.autoResult)
            });
          }
          if (node.children && node.children.length > 0) {
            collectLevel2AutoResults(node.children);
          }
        });
      };
      collectLevel2AutoResults(this.pageOneTreeData);

      return {
        datas: datas
      };
    },

    // 保存第二页数据为指定格式
    savePageTwoData () {
      const datas = [];
      const tableCheckFloorMap = {
        table1: 1,
        table2: 2,
        table3: 3,
        table4: 4,
        table5: 5,
        table6: 6,
        table7: 7
      };
      Object.keys(tableCheckFloorMap).forEach(tableId => {
        const tableConfig = this.goodsElevatorTables[tableId];
        if (!tableConfig) return;
        datas.push(...serializeGoodsElevatorTable(tableConfig, tableCheckFloorMap[tableId]));
      });
      return datas;
    },

    // 测试保存功能（可以在控制台查看结果）
    testSaveData () {
      console.log('当前pageOneData：', this.pageOneData);
      console.log('Level 3 items with itemNumber:', this.pageOneData.filter(item => item.level === 3 && item.itemNumber));
      console.log('Level 3 items with result:', this.pageOneData.filter(item => item.level === 3 && item.result));

      const pageOneResult = this.savePageOneData();
      const pageTwoResult = this.savePageTwoData();

      const allData = {
        datas: [...pageOneResult.datas, ...pageTwoResult]
      };

      console.log('第一页保存的数据：', JSON.stringify(pageOneResult, null, 2));
      console.log('第二页保存的数据：', JSON.stringify({ datas: pageTwoResult }, null, 2));
      console.log('合并后的数据格式：', JSON.stringify(allData, null, 2));
      this.$message.success('数据已输出到控制台，请按F12查看');
    },

    // 从URL参数初始化页面
    async initPageFromRoute () {
      this.pageLoading = true; // 开始加载

      console.log('接收到的url prop:', this.url);

      // 从url prop中解析查询参数
      let queryParams = {};
      if (this.url && this.url.includes('?')) {
        const queryString = this.url.split('?')[1];
        const urlParams = new URLSearchParams(queryString);
        urlParams.forEach((value, key) => {
          queryParams[key] = value;
        });
      }

      const dataKey = queryParams.dataKey;
      console.log('解析出的查询参数:', queryParams);
      console.log('获取到的dataKey:', dataKey);

      let recordData = {};

      if (dataKey) {
        // 从sessionStorage获取数据
        const storedData = sessionStorage.getItem(dataKey);
        console.log('从sessionStorage读取的原始数据:', storedData);
        if (storedData) {
          try {
            recordData = JSON.parse(storedData);
            console.log('从sessionStorage获取的数据:', recordData); this.recordData = recordData
            // 使用完后清理数据
            sessionStorage.removeItem(dataKey);
          } catch (error) {
            console.error('解析sessionStorage数据失败:', error);
          }
        } else {
          console.warn('sessionStorage中没有找到dataKey对应的数据:', dataKey);
        }
      } else {
        // 兼容旧的URL参数方式
        recordData = {
          entrustNum: queryParams.entrustNum || '',
          useUnitName: queryParams.useUnitName || '',
          elevatorCode: queryParams.elevatorCode || '',
          status: queryParams.status || '',
          productNumber: queryParams.productNumber || '',
          equipmentName: queryParams.equipmentName || ''
        };
        console.log('从URL参数获取的数据:', recordData);
      }

      // 设置记录信息
      this.recordInfo = {
        entrustNum: recordData.entrustNum || '',
        useUnitName: recordData.useUnitName || '',
        elevatorCode: recordData.elevatorCode || '',
        status: recordData.status || '',
        productNumber: recordData.productNumber || '',
        equipmentName: recordData.equipmentName || '',
        configReportPid: recordData.configReportPid || '',
        FIRST_YEAR: recordData.FIRST_YEAR || '',
      };

      this.pageOneTreeData = createDefaultPageOneTreeData();
      this.goodsElevatorTables = createDefaultGoodsElevatorTables();

      const today = new Date();
      const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

      // 初始化封面信息
      this.coverInfo = {
        entrustNum: this.recordInfo.entrustNum,
        useUnitName: this.recordInfo.useUnitName,
        // equipmentCode: this.recordInfo.elevatorCode,
        testDate: this.coverInfo.testDate || todayString,
        qrcodeImage: '',
        qrcodeBase64: ''
      };

      console.log('初始化记录信息:', this.recordInfo);

      try {
        // 并行执行初始化操作
        const initPromises = [
          // 初始化页面数据
          Promise.resolve(this.initializePageOneData()),
          // 获取人员选项
          this.getDetectionPersonnelOptions(),
          //this.getReviewPersonnelOptions(),
          // 获取设备选项
          this.getEquipmentOptions()
        ];

        // 如果有委托编号，加载暂存数据
        if (this.recordInfo.entrustNum) {
          initPromises.push(this.loadSavedData(this.recordInfo.entrustNum, this.recordInfo.status, this.recordInfo.FIRST_YEAR));
        }

        // 等待所有初始化操作完成
        await Promise.all(initPromises);

        // 初始化已选设备列表
        this.updateSelectedEquipments();

        // 自动加载工具箱及对应设备：
        // 只有 status===9（未录入）才使用默认工具箱/默认设备，其他状态直接使用 datas 回填
        if (Number(this.recordInfo.status) === 9) {
          await this.loadToolboxEqptInfos();
        }

        console.log('原始记录页面初始化完成');
      } catch (error) {
        console.error('初始化原始记录页面失败:', error);
        this.$message.error('初始化页面失败，请重试');
      } finally {
        this.pageLoading = false; // 结束加载
      }
    },

    // 返回上一页
    goBack () {
      // 在这个框架中，通过关闭当前标签页来返回
      // 尝试找到父组件的removeTab方法
      let parent = this.$parent;
      while (parent && !parent.removeTab) {
        parent = parent.$parent;
      }

      if (parent && parent.removeTab) {
        // 刷新父页面列表数据
        this.refreshParentList();

        // 获取当前标签页的name并关闭
        const currentTabName = parent.editableTabsValue;
        parent.removeTab(currentTabName);
      } else {
        // 如果找不到removeTab方法，尝试其他方式
        // 可以通过window.close()或者其他方式
        console.log('无法找到父组件的removeTab方法');
        // 作为备选方案，可以发送事件给父组件
        this.$emit('close');
      }
    },

    // 刷新父页面列表
    refreshParentList () {
      try {
        // 尝试通过 sessionStorage 触发父页面刷新
        const refreshKey = 'needRefreshOriginalManagement';
        sessionStorage.setItem(refreshKey, Date.now().toString());

        // 尝试直接调用父页面的刷新方法
        let parent = window.parent;
        if (parent && parent !== window) {
          // 尝试找到原始管理列表页面并触发刷新
          const frames = parent.frames;
          for (let i = 0; i < frames.length; i++) {
            try {
              const frame = frames[i];
              if (frame && frame.$vm && frame.$vm.$children) {
                // 查找原始管理列表组件
                const findListComponent = (components) => {
                  for (let comp of components) {
                    if (comp.$options && comp.$options.name === 'OriginalManagementList') {
                      return comp;
                    }
                    if (comp.$children && comp.$children.length > 0) {
                      const found = findListComponent(comp.$children);
                      if (found) return found;
                    }
                  }
                  return null;
                };

                const listComp = findListComponent(frame.$vm.$children);
                if (listComp && typeof listComp.getList === 'function') {
                  listComp.getList();
                  console.log('成功刷新父页面列表');
                  return;
                }
              }
            } catch (e) {
              // 跨域或其他错误，继续尝试
            }
          }
        }

        console.log('已设置刷新标记，父页面将在下次激活时刷新');
      } catch (error) {
        console.error('刷新父页面失败:', error);
      }
    },
    // 获取所有检验结果
    getAllResults () {
      const results = [];

      const collectResults = (nodes) => {
        nodes.forEach(node => {
          if (node.level === 3 && node.result) {
            results.push({
              id: node.id,
              itemNumber: node.itemNumber,
              description: node.description,
              result: node.result
            });
          }
          if (node.children) {
            collectResults(node.children);
          }
        });
      };

      collectResults(this.pageOneTreeData);
      return results;
    },

    // 二维码上传前的校验
    beforeQrcodeUpload (file) {
      const isImage = file.type.indexOf('image/') === 0;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('上传文件只能是图片格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },

    // 处理二维码上传
    handleQrcodeUpload (options) {
      const file = options.file;
      const reader = new FileReader();

      reader.onload = (e) => {
        const base64 = e.target.result;
        // 存储完整的base64数据用于显示
        this.coverInfo.qrcodeImage = base64;
        // 存储base64数据（去掉data:image/...;base64,前缀）用于提交
        this.coverInfo.qrcodeBase64 = base64.split(',')[1];

        this.$message.success('二维码上传成功!');
      };

      reader.onerror = () => {
        this.$message.error('图片读取失败!');
      };

      reader.readAsDataURL(file);
    },

    // 人员图片上传前的校验

    // 提交合并用：去掉值为 undefined 的顶层键，避免覆盖 additionalDataList 中接口带回的有效字段
    omitUndefinedTopLevel (obj) {
      if (!obj || typeof obj !== 'object') return obj;
      return Object.keys(obj).reduce((acc, key) => {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
      }, {});
    },

    // 构建API数据结构
    buildApiData () {
      // 构建字段映射数据结构
      const apiData = {
        // 封面信息字段映射
        recordNum: this.coverInfo.recordNum, // «recordNum»
        IMG_recordNumQrcode: this.coverInfo.qrcodeBase64, // «IMG_recordNumQrcode»
        USE_UNT_NAME: this.coverInfo.useUnitName, // «USE_UNT_NAME»
        EQP_STATION_COD: this.coverInfo.EQP_STATION_COD, // «EQP_STATION_COD»
        testDate: this.coverInfo.testDate, // «testDate»
        entrustNum: this.coverInfo.entrustNum,
        // 设备信息字段映射
        EQP_INNER_COD: this.equipmentInfo.unitInternalNumber, // «EQP_INNER_COD»
        USE_UNT_COD: this.equipmentInfo.USE_UNT_COD, // «USE_UNT_COD»
        EQP_VART_NAME: this.equipmentInfo.equipmentType, // «EQP_VART_NAME»
        EQP_SORT_NAME: this.coverInfo.EQP_SORT_NAME || this.equipmentInfo.eqpSortName || undefined,
        EQP_AREA_NAME: this.equipmentInfo.installLocation, // «EQP_AREA_NAME»
        EQP_MOD: this.equipmentInfo.productModel, // «EQP_MOD»
        EQP_USECERT_COD: this.equipmentInfo.registrationNumber, // «EQP_USECERT_COD»
        FACTORY_COD: this.equipmentInfo.productNumber, // «FACTORY_COD»
        powerSupply: this.equipmentInfo.powerSupply,
        humidity: this.equipmentInfo.humidity,
        temperature: this.equipmentInfo.temperature,
        MAKE_UNT_NAME: this.equipmentInfo.manufacturerName, // «MAKE_UNT_NAME»
        MAKE_DATE: this.equipmentInfo.manufactureDate, // «MAKE_DATE»
        renovation_unt_name: this.equipmentInfo.renovationUnitName, // «renovation_unt_name»
        renovation_date: this.equipmentInfo.renovationDate, // «renovation_date»
        service_unt_name: this.equipmentInfo.maintenanceUnit, // «service_unt_name»
        SAFE_MEN: this.equipmentInfo.safetyManager, // «SAFE_MEN»
        // 旧版曾用单一 RATEDLOAD 表示输送能力；现优先额定载重量，否则回退到输送能力以兼容旧数据
        RATEDLOAD: (() => {
          const rl = this.equipmentInfo.ratedLoad;
          const tc = this.equipmentInfo.transportCapacity;
          if (rl !== '' && rl != null && rl !== undefined) return rl;
          if (tc !== '' && tc != null && tc !== undefined) return tc;
          return undefined;
        })(),
        FLOOR_STADE_DOOR: this.equipmentInfo.floorStationDoor || undefined,
        RATEDVELOCITY: (this.equipmentInfo.ratedSpeed === '' || this.equipmentInfo.ratedSpeed === null || this.equipmentInfo.ratedSpeed === undefined)
          ? undefined
          : this.equipmentInfo.ratedSpeed,
        CONTROL_TYPE: this.equipmentInfo.controlMethod || undefined,
        RUNVELOCITY: (() => {
          const rv = this.equipmentInfo.nominalSpeed;
          if (rv === '' || rv === null || rv === undefined) return undefined;
          return rv;
        })(),
        DIP_ANGLE: this.equipmentInfo.inclinationAngle || undefined,
        NOMI_WIDTH: this.equipmentInfo.nominalWidth || undefined,
        TRANSPORT_CAPACITY: (this.equipmentInfo.transportCapacity === '' || this.equipmentInfo.transportCapacity === null || this.equipmentInfo.transportCapacity === undefined)
          ? undefined
          : this.equipmentInfo.transportCapacity,
        SLIDWAY_USE_LENG: (this.equipmentInfo.sectionLength === '' || this.equipmentInfo.sectionLength === null || this.equipmentInfo.sectionLength === undefined)
          ? undefined
          : this.equipmentInfo.sectionLength,
        ELEHEIGHT: (this.equipmentInfo.liftHeight === '' || this.equipmentInfo.liftHeight === null || this.equipmentInfo.liftHeight === undefined)
          ? undefined
          : this.equipmentInfo.liftHeight,
        OIDNO: this.equipmentInfo.oidNo || undefined,
        EQP_NAME: this.equipmentInfo.equipmentName || undefined,
        EQP_TEMP_NAME: this.equipmentInfo.eqpTempName || undefined,
        EQP_USE_ADDR: this.equipmentInfo.eqpUseAddr || undefined,
        ELEFLOORNUMBER: this.equipmentInfo.eleFloorNumber != null ? this.equipmentInfo.eleFloorNumber : undefined,
        ELESTADENUMBER: this.equipmentInfo.eleStadeNumber != null ? this.equipmentInfo.eleStadeNumber : undefined,
        ELEDOORNUMBER: this.equipmentInfo.eleDoorNumber != null ? this.equipmentInfo.eleDoorNumber : undefined,
        FIRST_YEAR: this.equipmentInfo.firstYear || this.recordInfo.FIRST_YEAR || undefined,
        EQP_REG_COD: (this.equipmentInfo.eqpRegCod === '' || this.equipmentInfo.eqpRegCod === undefined)
          ? undefined
          : this.equipmentInfo.eqpRegCod,
        testEmployeePid: this.equipmentInfo.detectionPersonnel, // 检测人员
        checkEmployeePid: this.equipmentInfo.reviewPersonnel, // 校核人员

        // 其他表单数据
        standardData: this.equipmentInfo.standardData,
        testConclusion: this.equipmentInfo.problemSummary ? this.equipmentInfo.problemSummary.replace(/\n/g, '\\n') : '', // «testConclusion» - 检测问题汇总
        testConclusionDesc: this.equipmentInfo.remarks ? this.equipmentInfo.remarks.replace(/\n/g, '\\n') : '', // «testConclusionDesc» - 备注
        nextTestDate: this.equipmentInfo.nextTestDate, // «nextTestDate» - 下次检测日期
        nextCheckDate: this.equipmentInfo.nextCheckDate, // «nextCheckDate» - 下次检验日期
        IMG_test: this.equipmentInfo.detectionPersonnelBase64, // «IMG_test» - 检测人员签名图片
        IMG_audit: this.equipmentInfo.reviewPersonnelBase64, // «IMG_audit» - 校核人员签名图片
        testEmployeeDate: this.equipmentInfo.detectionDate, // «testEmployeeDate» - 检测日期

        // 检验结果
        inspectionResults: this.getAllResults(),

        environmentConditions: {
          condition1Result: this.environmentConditionsData[0]?.confirmResult || '',
          condition2Result: this.environmentConditionsData[1]?.confirmResult || '',
          condition3Result: this.environmentConditionsData[2]?.confirmResult || '',
          condition4Result: this.environmentConditionsData[3]?.confirmResult || '',
          condition5Result: this.environmentConditionsData[4]?.confirmResult || '',
          condition6Result: this.environmentConditionsData[5]?.confirmResult || '',
          condition7Result: this.environmentConditionsData[6]?.confirmResult || '',
          condition8Result: this.environmentConditionsData[7]?.confirmResult || '',
          allConditions: this.environmentConditionsData
        },

        pageTwoTableData: {
          ...this.goodsElevatorTables
        }
      };

      return apiData;
    },

    // 根据 pageOneTreeData2.js 的树结构推导 testItemChildName
    // 规则：找到叶子节点（level=3对应的 configTestItemsContentCode）在树中的祖先链，
    // 返回链路最顶层节点的 itemNumber（去掉前导'*'）。
    // 如果树中找不到，则兜底使用按 '.' 截前三段的策略。
    getTestItemChildName (configTestItemsContentCode) {
      if (!configTestItemsContentCode || typeof configTestItemsContentCode !== 'string') return '';

      const normalize = (s) => {
        const v = String(s || '');
        return v.startsWith('*') ? v.substring(1) : v;
      };

      const target = normalize(configTestItemsContentCode);
      const tree = this.pageOneTreeData && Array.isArray(this.pageOneTreeData) ? this.pageOneTreeData : [];

      const findPath = (nodes) => {
        for (const node of nodes) {
          const nodeNum = normalize(node && (node.itemNumber || node.id));
          if (nodeNum && nodeNum === target) {
            return [node];
          }
          if (node && Array.isArray(node.children) && node.children.length > 0) {
            const childPath = findPath(node.children);
            if (childPath) return [node].concat(childPath);
          }
        }
        return null;
      };

      const path = findPath(tree);
      if (path && path.length > 0) {
        const topNode = path[0];
        const topVal = normalize(topNode && (topNode.itemNumber || topNode.id));
        return topVal || '';
      }

      // 兜底：按 '.' 截前三段
      const parts = target.split('.');
      if (parts.length >= 3) return parts.slice(0, 3).join('.');
      return target;
    },

    // 构建提交参数：infoList
    // 目标结构：
    // infoList: [{
    //   testItemChildName: 'A1.1.1',
    //   configTestItemsContentCode: 'A1.1.1.1.1',
    //   unqualifiedDetail: '[{ ...detail... }, ...]'
    // }]
    // 规则：遍历 additionalDataList.datas 中保存的“详情明细数组”(包含 contentDetailPid 的 JSON)，
    // 先筛选出 checkResult = 0 的明细，再按 configTestItemsContentCode 分组。
    buildInfoList (extraDatas = []) {
      const infoList = [];

      const baseDatas = this.additionalDataList && Array.isArray(this.additionalDataList.datas)
        ? this.additionalDataList.datas
        : [];
      const mergedDatas = baseDatas.concat(Array.isArray(extraDatas) ? extraDatas : []);
      if (mergedDatas.length === 0) {
        return infoList;
      }

      // key: configTestItemsContentCode（叶子编号，如 A1.1.1.1.1）
      // value: 该检验项下所有“不符合”的详情明细数组
      const groupMap = new Map();
      const seen = new Set(); // 避免同一 contentDetailPid 在同一检验项下重复
      const floorReferenceMap = new Map(); // key: configTestItemsContentCode, value: { appendixNo, floorValue }
      const buildFloorReferenceDetail = (code, appendixNo) => ({
        configReportPid: this.recordData ? this.recordData.configReportPid : null,
        configTestItemsContentCode: code,
        checkResult: 0,
        detailContent: `详见附表 ${appendixNo}`
      });

      mergedDatas.forEach(d => {
        if (!d || !d.dataValue) return;

        try {
          // 杂物梯附表 CheckFloor1-7
          if (typeof d.dataKey === 'string' && GOODS_ELEVATOR_FLOOR_APPENDIX_MAP[d.dataKey]) {
            const floorValue = String(d.dataValue || '').trim();
            if (floorValue) {
              const config = GOODS_ELEVATOR_FLOOR_APPENDIX_MAP[d.dataKey];
              const leafCode = config.leafCode;
              if (leafCode) {
                floorReferenceMap.set(leafCode, {
                  appendixNo: config.appendixText,
                  floorValue
                });
              }
            }
            return;
          }

          const parsed = JSON.parse(d.dataValue);
          if (!Array.isArray(parsed) || parsed.length === 0) return;
          // 兼容历史：旧版本把“未勾选详情占位”存进 datas，这里迁移为 infoList 结构
          if (
            d.dataKey &&
            d.dataKey.startsWith('__UNQUALIFIED_CUSTOM__') &&
            parsed[0] &&
            parsed[0].configTestItemsContentCode
          ) {
            const code = parsed[0].configTestItemsContentCode;
            infoList.push({
              testItemChildName: this.getTestItemChildName(code),
              configTestItemsContentCode: code,
              unqualifiedDetail: JSON.stringify([{
                configReportPid: parsed[0].configReportPid || (this.recordData ? this.recordData.configReportPid : null),
                configTestItemsContentCode: code,
                checkResult: 0
              }])
            });
            return;
          }
          if (!parsed[0] || !parsed[0].contentDetailPid) return; // 只处理详情明细数组

          const groupCheckResult = parsed[0].checkResult ?? 0;

          parsed.forEach(item => {
            if (!item || !item.contentDetailPid) return;

            const cr = item.checkResult ?? groupCheckResult;
            if (Number(cr) !== 0) return; // 只要“不符合”

            const code = item.configTestItemsContentCode || parsed[0].configTestItemsContentCode || d.dataKey;
            if (!code) return;

            const dupKey = `${code}__${item.contentDetailPid}`;
            if (seen.has(dupKey)) return;
            seen.add(dupKey);

            const list = groupMap.get(code) || [];
            list.push({
              ...item,
              checkResult: 0 // 明确标记为“不符合”
            });
            groupMap.set(code, list);
          });
        } catch (e) {
          // 非 JSON 或非详情结构，忽略
        }
      });

      groupMap.forEach((details, code) => {
        if (!details || details.length === 0) return;

        // 已存在“不符合详情”时，附加“详见附表xxxx”
        const floorReference = floorReferenceMap.get(code);
        if (floorReference && floorReference.appendixNo) {
          details.push(buildFloorReferenceDetail(code, floorReference.appendixNo));
        }

        const testItemChildName = this.getTestItemChildName(code);

        infoList.push({
          testItemChildName,
          configTestItemsContentCode: code,
          // 后端需要字符串形式的 JSON 数组
          unqualifiedDetail: JSON.stringify(details)
        });
      });

      // 合并弹窗内“未勾选详情”的自定义记录（去重：同 code 只保留一条）
      if (Array.isArray(this.unqualifiedCustomInfoList) && this.unqualifiedCustomInfoList.length > 0) {
        const existedCodeSet = new Set(infoList.map(i => i && i.configTestItemsContentCode).filter(Boolean));
        this.unqualifiedCustomInfoList.forEach(item => {
          if (!item || !item.configTestItemsContentCode || existedCodeSet.has(item.configTestItemsContentCode)) return;

          // “不符合且未勾选详情”场景：若附表有值，则把空白 detailContent 改为“详见附表xxxx”
          const floorReference = floorReferenceMap.get(item.configTestItemsContentCode);
          if (!floorReference || !floorReference.appendixNo) {
            infoList.push(item);
            existedCodeSet.add(item.configTestItemsContentCode);
            return;
          }

          let unqualifiedDetailList = [];
          try {
            const parsed = JSON.parse(item.unqualifiedDetail);
            if (Array.isArray(parsed)) {
              unqualifiedDetailList = parsed;
            }
          } catch (e) {
            unqualifiedDetailList = [];
          }

          const floorReferenceDetail = buildFloorReferenceDetail(
            item.configTestItemsContentCode,
            floorReference.appendixNo
          );
          if (unqualifiedDetailList.length === 0) {
            unqualifiedDetailList.push(floorReferenceDetail);
          } else {
            const target = unqualifiedDetailList[0] || {};
            unqualifiedDetailList[0] = {
              ...target,
              configReportPid: target.configReportPid || floorReferenceDetail.configReportPid,
              configTestItemsContentCode: target.configTestItemsContentCode || floorReferenceDetail.configTestItemsContentCode,
              checkResult: 0,
              detailContent: floorReferenceDetail.detailContent
            };
          }

          infoList.push({
            ...item,
            unqualifiedDetail: JSON.stringify(unqualifiedDetailList)
          });
          existedCodeSet.add(item.configTestItemsContentCode);
        });
      }

      // 只要附表表头(CheckFloor)有值，就确保对应检验项在 infoList 中至少有一条“详见附表xxx”记录。
      // 说明：该记录不依赖详情分组/占位数据，避免只填附表但没勾选详情时丢失“详见附表”信息。
      if (floorReferenceMap && floorReferenceMap.size > 0) {
        const existedCodeSet = new Set(infoList.map(i => i && i.configTestItemsContentCode).filter(Boolean));
        floorReferenceMap.forEach((floorReference, code) => {
          if (!code) return;
          if (!floorReference || !floorReference.appendixNo) return;
          const floorReferenceDetail = buildFloorReferenceDetail(code, floorReference.appendixNo);
          if (existedCodeSet.has(code)) {
            const target = infoList.find(i => i && i.configTestItemsContentCode === code);
            if (!target) return;
            let detailList = [];
            try {
              const parsed = JSON.parse(target.unqualifiedDetail);
              if (Array.isArray(parsed)) detailList = parsed;
            } catch (e) {
              detailList = [];
            }
            const withoutFloor = detailList.filter(detail => {
              const txt = detail && typeof detail.detailContent === 'string' ? detail.detailContent.trim() : '';
              return !txt.startsWith('详见附表');
            });
            const hasOnlyBlankPlaceholder = withoutFloor.length === 1 &&
              withoutFloor[0] &&
              !withoutFloor[0].contentDetailPid &&
              (withoutFloor[0].detailContent == null || String(withoutFloor[0].detailContent).trim() === '');
            const mergedList = hasOnlyBlankPlaceholder
              ? [floorReferenceDetail]
              : [...withoutFloor, floorReferenceDetail];
            target.unqualifiedDetail = JSON.stringify(mergedList);
            return;
          }
          infoList.push({
            testItemChildName: this.getTestItemChildName(code),
            configTestItemsContentCode: code,
            unqualifiedDetail: JSON.stringify([floorReferenceDetail])
          });
          existedCodeSet.add(code);
        });
      }

      return infoList;
    },


    reference () {
      if (this.referenceFilling || this.pageLoading) return;
      this.referenceDialogVisible = true;
    },

    // 处理参照数据确认（检测数据 + 层站设置 + 附表数据）
    async handleReferenceConfirm (payload) {
      if (this.referenceFilling) return;

      console.log('=== 开始回填参照数据 (RecordDialog2) ===');
      console.log('接收到的数据:', payload);

      this.referenceFilling = true;
      this.referenceDialogVisible = false;

      try {
        const elevSettingData = payload && payload.elevSettingData ? payload.elevSettingData : null;
        const rawDatas = payload && Array.isArray(payload.datas)
          ? payload.datas
          : (Array.isArray(payload) ? payload : []);
        const data = this.stripToolboxFromReferenceData({
          ...(payload && !Array.isArray(payload) ? payload : {}),
          datas: rawDatas
        });
        delete data.elevSettingData;

        if (!data || typeof data !== 'object') {
          this.$message.warning('返回数据格式不正确');
          return;
        }

        // 扶梯/人行道原始记录不涉及电梯层站附表，但若父组件具备层站同步能力则先执行
        if (elevSettingData && typeof elevSettingData === 'object' && typeof this.syncReferenceElevatorSetting === 'function') {
          await this.syncReferenceElevatorSetting(elevSettingData);
        }

        // 统一回填（不含工具箱/仪器设备）
        this.additionalDataList = data;
        if (typeof this.initPreviousSelectedDetailPids === 'function') {
          this.initPreviousSelectedDetailPids();
        }
        this.fillFormData(data, { skipToolbox: true });
        this.syncAdditionalDataListPageTwoFromUI();

        this.$message.success('参照数据回填成功');
      } catch (error) {
        console.error('回填数据失败:', error);
        this.$message.error('回填数据失败，请查看控制台');
      } finally {
        this.referenceFilling = false;
        console.log('=== 回填完成 ===');
      }
    },

    // 回填检测结果数据
    fillTestResults (datas) {
      console.log('开始回填检测结果数据:', datas);

      let successCount = 0;

      // 遍历返回的数据，匹配并回填到 pageOneData
      datas.forEach(item => {
        const dataKey = item.dataKey;
        const dataValue = item.dataValue;

        // 去掉可能的*前缀
        const cleanDataKey = dataKey.startsWith('*') ? dataKey.substring(1) : dataKey;

        // 在 pageOneData 中查找对应的项目
        const targetRow = this.pageOneData.find(row => row.itemNumber === cleanDataKey);

        if (targetRow && targetRow.level === 3) {
          // 将文本结果转换为内部值
          let resultValue = '';
          if (dataValue === '符合' || dataValue === '合格') {
            resultValue = 'qualified';
          } else if (dataValue === '不符合' || dataValue === '不合格') {
            resultValue = 'unqualified';
          } else if (dataValue === '无此项') {
            resultValue = 'notApplicable';
          } else {
            // 如果是其他值，尝试直接使用
            resultValue = dataValue;
          }

          targetRow.result = resultValue;
          successCount++;
          console.log(`回填 ${cleanDataKey}: ${dataValue} -> ${resultValue}`);
        }
      });

      console.log(`成功回填 ${successCount} 条数据`);

      // 重新计算综合检验结果 - 遍历所有 level 3 项目并更新父级
      const level3Items = this.pageOneData.filter(item => item.level === 3 && item.result);
      level3Items.forEach(item => {
        this.updateParentAutoResult(item);
      });

      // 强制刷新表格以更新样式
      this.$nextTick(() => {
        if (this.$refs.pageOneTable) {
          this.$refs.pageOneTable.doLayout();
        }
      });
    },

    // 提交表单
    handleSubmit (type) {
      // 提交中禁止重复点击；完成后关页前也保持 loading，避免再点保存冲掉 OperatorDate
      if (this.loading) return;

      console.log('下次检测日期:', this.equipmentInfo.nextTestDate);
      console.log('下次检验日期:', this.equipmentInfo.nextCheckDate);

      this.loading = true;
      // 提交前同步附表 datas，确保已清空的单元格不会从 additionalDataList 旧数据中回填
      this.syncAdditionalDataListPageTwoFromUI();
      // 构建API数据（此时备注已经包含了新添加的详情文本）
      const apiData = this.buildApiData();

      // 合并第一页和第二页的数据
      const pageOneData = this.savePageOneData().datas;
      const pageTwoData = this.savePageTwoData();
      // 新增：提交参数 infoList（勾选的不符合明细）
      // 传入 pageTwoData，确保本次提交时最新的 CheckFloor 值能参与“详见附表”拼装。
      apiData.infoList = this.buildInfoList(pageTwoData);
      apiData.datas = [...pageOneData, ...pageTwoData];
      // 处理dataKey，去除开头的*号（后端识别不了*）
      apiData.datas = apiData.datas.map(item => ({
        ...item,
        dataKey: item.dataKey.startsWith('*') ? item.dataKey.substring(1) : item.dataKey
      }));

      // 提交工具箱号（用于下次打开回填）
      // 先剔除同 key 的旧值，避免重复导致取值不确定
      const toolboxKey = this.getToolboxDataKey();
      apiData.datas = apiData.datas.filter(d => !(d && d.dataKey === toolboxKey));
      if (this.selectedToolboxNum) {
        apiData.datas.push({
          dataKey: toolboxKey,
          dataValue: this.selectedToolboxNum
        });
      }

      // 将设备仪器数据添加到datas数组中(包含名称、管理编号、使用记录)
      const equipmentData = [
        {
          index: 0,
          key: 'EquipmentName01',
          name: this.getEquipmentNameById(this.instrumentTableData[0]?.name),
          mgmtNo: this.instrumentTableData[0]?.managementNumber,
          usage: this.instrumentTableData[0]?.usageRecord
        },
        {
          index: 1,
          key: 'EquipmentName02',
          name: this.getEquipmentNameById(this.instrumentTableData[1]?.name),
          mgmtNo: this.instrumentTableData[1]?.managementNumber,
          usage: this.instrumentTableData[1]?.usageRecord
        },
        {
          index: 2,
          key: 'EquipmentName03',
          name: this.getEquipmentNameById(this.instrumentTableData[2]?.name),
          mgmtNo: this.instrumentTableData[2]?.managementNumber,
          usage: this.instrumentTableData[2]?.usageRecord
        },
        {
          index: 3,
          key: 'EquipmentName04',
          name: this.getEquipmentNameById(this.instrumentTableData[3]?.name),
          mgmtNo: this.instrumentTableData[3]?.managementNumber,
          usage: this.instrumentTableData[3]?.usageRecord
        },
        {
          index: 4,
          key: 'EquipmentName05',
          name: this.getEquipmentNameById(this.instrumentTableData[4]?.name),
          mgmtNo: this.instrumentTableData[4]?.managementNumber,
          usage: this.instrumentTableData[4]?.usageRecord
        },
        {
          index: 5,
          key: 'EquipmentName06',
          name: this.getEquipmentNameById(this.instrumentTableData[5]?.name),
          mgmtNo: this.instrumentTableData[5]?.managementNumber,
          usage: this.instrumentTableData[5]?.usageRecord
        },
        {
          index: 6,
          key: 'EquipmentName07',
          name: this.getEquipmentNameById(this.instrumentTableData[6]?.name),
          mgmtNo: this.instrumentTableData[6]?.managementNumber,
          usage: this.instrumentTableData[6]?.usageRecord
        },
        {
          index: 7,
          key: 'EquipmentName08',
          name: this.getEquipmentNameById(this.instrumentTableData[7]?.name),
          mgmtNo: this.instrumentTableData[7]?.managementNumber,
          usage: this.instrumentTableData[7]?.usageRecord
        },
        {
          index: 8,
          key: 'EquipmentName09',
          name: this.getEquipmentNameById(this.instrumentTableData[8]?.name),
          mgmtNo: this.instrumentTableData[8]?.managementNumber,
          usage: this.instrumentTableData[8]?.usageRecord
        },
        {
          index: 9,
          key: 'EquipmentName10',
          name: this.getEquipmentNameById(this.instrumentTableData[9]?.name),
          mgmtNo: this.instrumentTableData[9]?.managementNumber,
          usage: this.instrumentTableData[9]?.usageRecord
        },
        {
          index: 0,
          key: 'EquipmentName11',
          name: this.getEquipmentNameById(this.instrumentTableData[0]?.name2),
          mgmtNo: this.instrumentTableData[0]?.managementNumber2,
          usage: this.instrumentTableData[0]?.usageRecord2
        },
        {
          index: 1,
          key: 'EquipmentName12',
          name: this.getEquipmentNameById(this.instrumentTableData[1]?.name2),
          mgmtNo: this.instrumentTableData[1]?.managementNumber2,
          usage: this.instrumentTableData[1]?.usageRecord2
        },
        {
          index: 2,
          key: 'EquipmentName13',
          name: this.getEquipmentNameById(this.instrumentTableData[2]?.name2),
          mgmtNo: this.instrumentTableData[2]?.managementNumber2,
          usage: this.instrumentTableData[2]?.usageRecord2
        },
        {
          index: 3,
          key: 'EquipmentName14',
          name: this.getEquipmentNameById(this.instrumentTableData[3]?.name2),
          mgmtNo: this.instrumentTableData[3]?.managementNumber2,
          usage: this.instrumentTableData[3]?.usageRecord2
        },
        {
          index: 4,
          key: 'EquipmentName15',
          name: this.getEquipmentNameById(this.instrumentTableData[4]?.name2),
          mgmtNo: this.instrumentTableData[4]?.managementNumber2,
          usage: this.instrumentTableData[4]?.usageRecord2
        },
        {
          index: 5,
          key: 'EquipmentName16',
          name: this.getEquipmentNameById(this.instrumentTableData[5]?.name2),
          mgmtNo: this.instrumentTableData[5]?.managementNumber2,
          usage: this.instrumentTableData[5]?.usageRecord2
        },
        {
          index: 6,
          key: 'EquipmentName17',
          name: this.getEquipmentNameById(this.instrumentTableData[6]?.name2),
          mgmtNo: this.instrumentTableData[6]?.managementNumber2,
          usage: this.instrumentTableData[6]?.usageRecord2
        },
        {
          index: 7,
          key: 'EquipmentName18',
          name: this.getEquipmentNameById(this.instrumentTableData[7]?.name2),
          mgmtNo: this.instrumentTableData[7]?.managementNumber2,
          usage: this.instrumentTableData[7]?.usageRecord2
        },
        {
          index: 8,
          key: 'EquipmentName19',
          name: this.getEquipmentNameById(this.instrumentTableData[8]?.name2),
          mgmtNo: this.instrumentTableData[8]?.managementNumber2,
          usage: this.instrumentTableData[8]?.usageRecord2
        },
        {
          index: 9,
          key: 'EquipmentName20',
          name: this.getEquipmentNameById(this.instrumentTableData[9]?.name2),
          mgmtNo: this.instrumentTableData[9]?.managementNumber2,
          usage: this.instrumentTableData[9]?.usageRecord2
        },
      ];

      // 单独添加 Result01-07 数据到 datas（第1-7条独立确认）
      apiData.datas.push({
        dataKey: 'Result01',
        dataValue: this.environmentConditionsData[0]?.confirmResult == 'qualified' ? '是' : '否',// «Result1» - 第1条结果
      });
      apiData.datas.push({
        dataKey: 'Result02',
        dataValue: this.environmentConditionsData[1]?.confirmResult == 'qualified' ? '是' : '否',// «Result2» - 第2条结果
      });
      apiData.datas.push({
        dataKey: 'Result03',
        dataValue: this.environmentConditionsData[2]?.confirmResult == 'qualified' ? '是' : '否',// «Result3» - 第3条结果
      });
      apiData.datas.push({
        dataKey: 'Result04',
        dataValue: this.environmentConditionsData[3]?.confirmResult == 'qualified' ? '是' : '否',// «Result4» - 第4条结果
      });
      apiData.datas.push({
        dataKey: 'Result05',
        dataValue: this.environmentConditionsData[4]?.confirmResult == 'qualified' ? '是' : '否',// «Result5» - 第5条结果
      });
      apiData.datas.push({
        dataKey: 'Result06',
        dataValue: this.environmentConditionsData[5]?.confirmResult == 'qualified' ? '是' : '否',// «Result6» - 第6条结果
      });
      apiData.datas.push({
        dataKey: 'Result07',
        dataValue: this.environmentConditionsData[6]?.confirmResult == 'qualified' ? '是' : '否',
      });
      apiData.datas.push({
        dataKey: 'Result08',
        dataValue: this.environmentConditionsData[7]?.confirmResult == 'qualified' ? '是' : '否',
      });

      // 只添加有名称的设备数据，分别保存名称、管理编号、使用记录
      equipmentData.forEach(item => {
        if (item.name) {
          // 保存设备名称
          apiData.datas.push({
            dataKey: item.key,
            dataValue: item.name
          });

          // 保存管理编号
          const mgmtKey = item.key.replace('EquipmentName', 'MgmtNo');
          if (item.mgmtNo) {
            apiData.datas.push({
              dataKey: mgmtKey,
              dataValue: item.mgmtNo
            });
          }

          // 保存使用记录
          const usageKey = item.key.replace('EquipmentName', 'V');
          if (item.usage) {
            apiData.datas.push({
              dataKey: usageKey,
              dataValue: item.usage
            });
          }
        }
      });

      // 添加详情数据（从additionalDataList.datas中获取）
      if (this.additionalDataList && this.additionalDataList.datas && Array.isArray(this.additionalDataList.datas)) {
        // 先筛选出“看起来是详情数据”的项，并解析出第一条明细，方便后续去重 / 选优
        const rawDetailItems = this.additionalDataList.datas
          .map(item => {
            if (!item.dataKey || !item.dataValue) return null;
            try {
              const parsed = JSON.parse(item.dataValue);
              if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid) {
                return { item, firstDetail: parsed[0] };
              }
            } catch (e) {
              return null;
            }
            return null;
          })
          .filter(v => v);

        // 按同一个 configTestItemsContentCode 去重：
        // - 如果有老数据（没有 detailCode）和新数据（有 detailCode），优先保留“有 detailCode 的”
        const mergedDetailMap = {};
        rawDetailItems.forEach(({ item, firstDetail }) => {
          const code = firstDetail.configTestItemsContentCode || item.dataKey;
          const existed = mergedDetailMap[code];
          if (!existed) {
            mergedDetailMap[code] = { item, firstDetail };
          } else {
            const existedHasDetailCode = !!(existed.firstDetail && existed.firstDetail.detailCode);
            const currentHasDetailCode = !!firstDetail.detailCode;
            // 当前这条有 detailCode，而已有那条没有，则用当前的覆盖
            if (!existedHasDetailCode && currentHasDetailCode) {
              mergedDetailMap[code] = { item, firstDetail };
            }
          }
        });

        // 将去重后的详情数据添加到提交数据中
        Object.values(mergedDetailMap).forEach(({ item, firstDetail }) => {
          // 先去掉*号
          let detailKey = item.dataKey.startsWith('*') ? item.dataKey.substring(1) : item.dataKey;

          // 如果明细里已经带有 detailCode（如 A1.1.1.1.1-4），则优先使用它作为 dataKey
          if (firstDetail && firstDetail.detailCode) {
            detailKey = firstDetail.detailCode;
          }

          // 如果与检验结果或其他数据使用同一个 dataKey（例如 A1.1.1.1.1），
          // 则在提交详情数据时追加后缀 "-4"，避免覆盖检验结果数据
          if (apiData.datas.some(d => d.dataKey === detailKey)) {
            // 如果本身已经是 detailCode（如 A1.1.1.1.1-4），则不重复追加
            if (!/-\d+$/.test(detailKey)) {
              detailKey = `${detailKey}-4`;
            }
          }

          apiData.datas.push({
            dataKey: detailKey,
            dataValue: item.dataValue
          });
        });
      }

      apiData.type = type
      // 修改合并顺序:让apiData覆盖additionalDataList,确保用户修改的值不会被覆盖
      const apiPayload = this.omitUndefinedTopLevel(apiData);
      let data = { ...this.additionalDataList, ...apiPayload, configReportPid: this.recordInfo.configReportPid }
      saveTestData(data).then(response => {

        console.log(response);
        // this.$message.success('原始记录录入成功');
        if (response.retCode == "ok") {
          this.$message.success('原始记录录入成功');
          if (type == 3 || type === '3') {
            // 完成后保持禁用直到关页，防止延迟关闭期间再点保存删除 OperatorDate
            setTimeout(() => {
              this.goBack();
            }, 1500); // 延迟1.5秒让用户看到成功消息
            return;
          }
        } else {
          this.$message.error(response.retMsg || '录入失败');
        }
        this.loading = false;
        // 保存成功后关闭当前标签页
      }).catch(error => {
        this.$message.error('录入失败：' + error.message);
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
/* 页面容器样式 */
.record-page {
  height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 页面头部样式 */
.page-header {
  background-color: #fff;
  padding: 5px 24px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
}

.back-button {
  font-size: 16px;
  margin-right: 16px;
  color: #409eff;
}

.back-button:hover {
  color: #66b1ff;
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.header-right {
  display: flex;
  gap: 12px;
}

/* 主要内容区域 */
.page-content {
  flex: 1;
  padding: 24px 24px 96px;
  overflow-y: auto;
  height: 0; /* 这个很重要，让flex子元素能够正确计算高度 */
}

/* 页面加载遮罩层样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 基本信息卡片样式 */
.info-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
  color: #303133;
}

.card-header-qrcode {
  width: 50px;
  height: 50px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

.header-qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.equipment-params-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.params-title-wrapper {
  flex: 1;
}

.params-title-text {
  font-weight: bold;
  font-size: 14px;
  color: #303133;
  padding: 8px 12px;
  background-color: #f5f7fa;
  border-left: 4px solid #409eff;
}

.params-qrcode {
  width: 50px;
  height: 50px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin-left: 10px;
}

.params-qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.info-item {
  margin-bottom: 15px;
  padding: 8px 0;
}

.info-item .label {
  font-weight: bold;
  color: #606266;
  display: inline-block;
  min-width: 80px;
}

.info-item .value {
  color: #303133;
  margin-left: 8px;
}

/* 页面内容滚动样式 */
.page-content::-webkit-scrollbar {
  width: 8px;
}

.page-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.page-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.page-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 页面卡片样式 */
.page-card {
  margin-bottom: 24px;
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
  border-radius: 8px;
  background-color: #fff;
}

.page-card:hover {
  border-color: #409eff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-content {
  min-height: 200px;
  padding: 24px;
}

/* 第一页左右两栏布局样式 */
.page-one-layout {
  display: flex;
  height: 700px;
  gap: 16px;
  min-height: 700px;
  max-height: 700px; /* 确保不会超出高度 */
  /* 正文主色：子级 el-table 默认 #606266，在此设主色并由表格 inherit 覆盖组件库默认 */
  color: #303133;
}

.page-one-layout ::v-deep .el-table {
  color: inherit;
}

/* 左侧导航面板样式 */
.navigation-panel {
  width: 15%;
  background-color: #f8f9fa;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.nav-title {
  background-color: #409eff;
  color: white;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}

.nav-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.nav-item {
  padding: 8px 16px;
  cursor: pointer;
  border-bottom: 1px solid #ebeef5;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nav-item:hover {
  background-color: #ecf5ff;
  border-left: 3px solid #409eff;
}

.nav-item.active {
  background-color: #409eff;
  color: white;
  border-left: 3px solid #1890ff;
}

.nav-item.active:hover {
  background-color: #337ecc;
}

.nav-item-level-2 {
  padding-left: 24px;
}

.nav-number {
  font-weight: 600;
  font-size: 12px;
  color: #409eff;
}

.nav-item.active .nav-number {
  color: white;
}

.nav-description {
  font-size: 11px;
  color: #606266;
  line-height: 1.3;
  word-break: break-all;
}

.nav-item.active .nav-description {
  color: rgba(255, 255, 255, 0.9);
}

/* 右侧表格面板样式 */
.table-panel {
  width: 85%;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  height: 100%;
  position: relative;
}

/* 强制表格显示滚动条 */
.table-panel .el-table {
  height: 100% !important;
}

.table-panel .el-table .el-table__body-wrapper {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

/* 强制显示滚动条 */
.table-panel .el-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px !important;
  display: block !important;
}

.table-panel .el-table .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1 !important;
  border-radius: 4px !important;
}

.table-panel .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1 !important;
  border-radius: 4px !important;
}

.table-panel .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8 !important;
}

/* 确保表格内容可以滚动 */
.table-panel .el-table__body {
  overflow: visible !important;
}

/* 为Firefox浏览器添加滚动条样式 */
.table-panel .el-table .el-table__body-wrapper {
  scrollbar-width: thin !important;
  scrollbar-color: #c1c1c1 #f1f1f1 !important;
}

/* 高亮行样式 */
.highlight-row {
  background-color: #fff7e6 !important;
  animation: highlight-fade 3s ease-out;
}

@keyframes highlight-fade {
  0% {
    background-color: #ffd591 !important;
  }
  100% {
    background-color: #fff7e6 !important;
  }
}

.placeholder-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  background-color: #fafafa;
  border: 2px dashed #dcdfe6;
  border-radius: 4px;
  color: #909399;
  font-size: 14px;
}

.placeholder-content p {
  margin: 0;
  text-align: center;
}

/* 底部按钮样式 */
.dialog-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
  margin-top: 20px;
}

/* 表格内容样式 */
.item-content {
  padding: 6px 8px;
  line-height: 1.5;
}

.item-visited-icon {
  color: #f56c6c;
  width: 24px;
  display: inline-block;
  text-align: center;
  margin-right: 4px;
  font-size: 20px;
  visibility: hidden;
}

.item-visited-icon.is-visible {
  visibility: visible;
}

.item-content-a13141 {
  align-items: flex-start;
}

.item-a13141-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  padding-left: 10px;
}

/* 第一层级样式 - 主要分类 */
.level-1 {
  font-weight: bold;
}

.level-1-number {
  font-weight: bold;
  color: #409eff;
  font-size: 18px;
  margin-right: 8px;
}

.level-1-desc {
  font-weight: bold;
  color: #303133;
  font-size: 18px;
  text-align: left;
}

/* 第二层级样式 - 子分类 */
.level-2 {
  padding-left: 20px;
}

.level-2-number {
  font-weight: bold;
  color: #409eff;
  font-size: 16px;
  margin-right: 8px;
}

.level-2-desc {
  font-weight: 600;
  color: #606266;
  font-size: 16px;
  text-align: left;
}

/* 第三层级样式 - 具体检测项 */
.level-3 {
  padding-left: 40px;
}

.level-3-number {
  font-weight: normal;
  color: #909399;
  font-size: 16px;
  margin-right: 6px;
}

.level-3-desc {
  /* <!-- color: #606266; --> */
  font-size: 16px;
  line-height: 1.6;
  text-align: left;
}

/* 表格行样式 */
.el-table .el-table__row {
  height: auto;
}

.el-table .el-table__cell {
  padding: 8px 0;
}

/* 下拉框样式 */
.el-select {
  width: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-header {
    padding: 5px 16px;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .header-left {
    justify-content: flex-start;
  }

  .header-right {
    justify-content: center;
  }

  .page-content {
    padding: 24px 24px 96px;
    height: 0; /* 这个很重要，让flex子元素能够正确计算高度 */
  }

  .card-content {
    min-height: 150px;
    padding: 16px;
  }

  .placeholder-content {
    height: 120px;
  }

  .item-description {
    font-size: 12px;
  }

  .page-title {
    font-size: 18px;
  }
}

/* 第二页表格样式 */
.page-two-content {
  padding: 20px;
}

.table-section {
  margin-bottom: 30px;
}

.table-title {
  font-weight: bold;
  font-size: 14px;
  color: #303133;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-left: 4px solid #409eff;
}

/* 表格滚动容器 */
.table-scroll-wrapper {
  overflow-x: auto;
  overflow-y: visible;
}

/* 自定义水平滚动条样式 */
.table-scroll-wrapper::-webkit-scrollbar {
  height: 10px;
}

.table-scroll-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 分割单元格样式 */
.split-cell {
  position: relative;
  min-height: 80px;
  padding: 8px;
}

.cell-top-left {
  position: absolute;
  top: 8px;
  left: 8px;
  width: calc(50% - 12px);
}

.cell-bottom-right {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: calc(50% - 12px);
}

.split-cell::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom right, transparent 0%, transparent calc(50% - 1px), #dcdfe6 calc(50% - 1px), #dcdfe6 calc(50% + 1px), transparent calc(50% + 1px), transparent 100%);
  pointer-events: none;
}

.empty-cell {
  text-align: center;
  color: #909399;
}

.header-cell {
  text-align: center;
  font-weight: bold;
  color: #303133;
}

/* 表格内输入框样式 */
.split-cell .el-input__inner {
  padding: 5px 8px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
}

/* 行标签样式 */
.row-label {
  font-weight: bold;
  color: #303133;
  padding: 8px;
  text-align: center;
}

/* 表格信息行样式 */
.table-info-row {
  margin-bottom: 15px;
  padding: 15px;
  background-color: #f9f9f9;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.info-item-inline {
  display: flex;
  align-items: center;
}

.info-item-inline .label {
  font-weight: bold;
  color: #606266;
  white-space: nowrap;
  margin-right: 8px;
  min-width: 80px;
}

.info-item-inline .el-input {
  flex: 1;
}

/* 填写说明样式 */
.instructions-content {
  padding: 20px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
}

.instructions-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 20px 0;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 2px solid #409eff;
}

.instructions-list {
  line-height: 1.8;
}

.instruction-item {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
}

.instruction-number {
  font-weight: bold;
  color: #409eff;
  min-width: 40px;
  flex-shrink: 0;
  font-size: 14px;
}

.instruction-text {
  color: #303133;
  font-size: 14px;
  line-height: 1.6;
  flex: 1;
}

/* 封面页样式 */
.cover-content {
  padding: 40px 60px;
  min-height: 600px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cover-top-row {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 40px;
  margin-bottom: 20px;
}

.cover-record-number {
  display: flex;
  align-items: center;
}

.cover-label {
  font-weight: bold;
  color: #303133;
  font-size: 16px;
  margin-right: 10px;
  white-space: nowrap;
}

.cover-input {
  width: 300px;
}

.cover-spacer {
  height: 60px;
}

.cover-spacer-large {
  height: 80px;
}

.cover-title-section {
  text-align: center;
  margin: 40px 0;
}

.cover-main-title {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 20px 0;
  line-height: 1.4;
}

.cover-sub-title {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin: 0;
  line-height: 1.4;
}

.cover-info-section {
  margin: 40px auto;
  max-width: 500px;
  text-align: center;
}

.cover-info-row {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  padding: 0 20px;
}

.cover-info-label {
  font-weight: bold;
  color: #303133;
  font-size: 16px;
  min-width: 140px;
  white-space: nowrap;
}

.cover-info-input {
  width: 300px;
  margin-left: 20px;
}

.cover-info-value {
  color: #303133;
  font-size: 16px;
  margin-left: 20px;
}

.cover-company {
  text-align: center;
  margin-top: 40px;
}

.cover-company-name {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin: 0;
}

/* 二维码上传样式 */
.cover-qrcode-section {
  margin-bottom: 0;
}

.cover-qrcode-upload {
  display: flex;
  align-items: flex-start;
}

.qrcode-upload-area {
  margin-left: 10px;
}

.qrcode-uploader {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.qrcode-uploader:hover {
  border-color: #409eff;
}

.qrcode-upload-placeholder {
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
}

.qrcode-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  margin-bottom: 8px;
}

.qrcode-uploader-text {
  color: #606266;
  font-size: 14px;
}

.qrcode-preview {
  position: relative;
  width: 120px;
  height: 120px;
}

.qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.qrcode-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 4px;
  color: white;
  font-size: 12px;
}

.qrcode-preview:hover .qrcode-overlay {
  opacity: 1;
}

.qrcode-overlay i {
  font-size: 20px;
  margin-bottom: 4px;
}

/* 二维码显示样式（仅显示，不可上传） */
.qrcode-display {
  width: 120px;
  height: 120px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
  overflow: hidden;
}

.qrcode-display .qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.qrcode-empty-placeholder {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
}

/* 人员签名上传样式 */
.personnel-upload-area {
  margin-left: 10px;
}

.personnel-uploader {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.personnel-uploader:hover {
  border-color: #409eff;
}

.personnel-upload-placeholder {
  width: 150px;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
}

.personnel-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  margin-bottom: 6px;
}

.personnel-uploader-text {
  color: #606266;
  font-size: 12px;
  text-align: center;
}

.personnel-preview {
  position: relative;
  width: 150px;
  height: 80px;
}

.personnel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.personnel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 4px;
  color: white;
  font-size: 11px;
}

.personnel-preview:hover .personnel-overlay {
  opacity: 1;
}

.personnel-overlay i {
  font-size: 16px;
  margin-bottom: 3px;
}

/* 响应式设计 - 封面页 */
@media (max-width: 768px) {
  .cover-content {
    padding: 20px 30px;
    min-height: 500px;
  }

  .cover-main-title {
    font-size: 22px;
  }

  .cover-sub-title {
    font-size: 18px;
  }

  .cover-info-row {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .cover-info-input {
    width: 100%;
    margin-left: 0;
    margin-top: 8px;
  }

  .cover-info-value {
    margin-left: 0;
    margin-top: 8px;
  }

  .cover-input {
    width: 100%;
  }

  .cover-spacer,
  .cover-spacer-large {
    height: 30px;
  }

  .cover-top-row {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .cover-qrcode-upload {
    flex-direction: column;
    align-items: flex-start;
  }

  .qrcode-upload-area {
    margin-left: 0;
    margin-top: 8px;
  }

  .qrcode-upload-placeholder,
  .qrcode-preview {
    width: 100px;
    height: 100px;
  }
}

/* 设备信息卡片样式 */
.equipment-info-content {
  padding: 20px;
}

.equipment-basic-info,
.equipment-params,
.detection-basis {
  margin-bottom: 20px;
}

.info-table-row {
  border: 1px solid #e4e7ed;
  margin-bottom: 0;
}

.info-label-col {
  background-color: #f5f7fa;
  border-right: 1px solid #e4e7ed;
  padding: 8px 12px;
  font-weight: bold;
  color: #303133;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
}

.info-label-col-vertical {
  background-color: #f5f7fa;
  border-right: 1px solid #e4e7ed;
  padding: 8px 12px;
  font-weight: bold;
  color: #303133;
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-rl;
  text-orientation: upright;
  min-height: 120px;
}

.info-label-col-empty {
  background-color: #f5f7fa;
  border-right: 1px solid #e4e7ed;
  min-height: 40px;
}

.info-input-col {
  border-right: 1px solid #e4e7ed;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  min-height: 40px;
}

.info-input-col:last-child {
  border-right: none;
}

.instrument-table-section,
.environment-conditions-section {
  margin-bottom: 20px;
}

.section-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.section-title {
  font-weight: bold;
  font-size: 16px;
  color: #303133;
  padding: 10px;
  background-color: #f5f7fa;
  border-left: 4px solid #409eff;
  flex: 1;
}

.toolbox-selector {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.summary-section {
  margin-bottom: 20px;
}

.summary-item {
  margin-bottom: 15px;
}

.summary-label {
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
}

.signature-section {
  border-top: 1px solid #e4e7ed;
  padding-top: 20px;
}

.signature-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.signature-label {
  font-weight: bold;
  color: #303133;
  margin-right: 10px;
  white-space: nowrap;
}

/* 响应式设计 - 设备信息 */
@media (max-width: 768px) {
  .equipment-info-content {
    padding: 15px;
  }

  .info-label-col-vertical {
    writing-mode: horizontal-tb;
    text-orientation: mixed;
    min-height: 40px;
  }

  .signature-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .signature-label {
    margin-bottom: 8px;
  }
}

/* 响应式设计 - 填写说明 */
@media (max-width: 768px) {
  .instructions-content {
    padding: 15px;
  }

  .instructions-title {
    font-size: 16px;
  }

  .instruction-text {
    font-size: 13px;
  }

  .instruction-number {
    min-width: 35px;
    font-size: 13px;
  }
}

/* 检验结果样式 */
.result-pass {
  color: #67c23a;
  font-weight: bold;
}

.result-fail {
  color: #f56c6c;
  font-weight: bold;
}

.item-content {
  display: flex;
  align-items: center;
  text-align: left;
}

.item-image-wrapper {
  margin-top: 8px;
}

.item-image {
  max-width: 100%;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.item-number {
  margin-right: 8px;
  font-weight: bold;
  white-space: nowrap;
  flex-shrink: 0;
}

.level-1-number {
  color: #409eff;
}

.level-2-number {
  color: #67c23a;
}

.level-3-number {
  color: #e6a23c;
}

/* 禁用的综合检验结果下拉框样式 */
.el-select.is-disabled .el-input__inner {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed !important;
  color: #606266 !important;
}

.el-select.is-disabled .el-input__inner[aria-expanded='false'] {
  background-color: #f5f7fa !important;
}

/* 合格状态的下拉框 */
.auto-result-qualified .el-input__inner {
  color: #67c23a !important;
  font-weight: bold !important;
}

/* 不合格状态的下拉框 */
.auto-result-unqualified .el-input__inner {
  color: #f56c6c !important;
  font-weight: bold !important;
}

/* 检验结果颜色块样式 */
.result-color-block {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  min-width: 90px;
  max-width: 90px;
  min-height: 50px; /* 增加高度以容纳两行 */
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  box-sizing: border-box;
}

.result-color-block:hover {
  opacity: 0.8;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.result-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.result-text {
  color: #fff;
  font-weight: 500;
  line-height: 1.5;
}

.attachment-info {
  color: #fff;
  font-size: 11px;
  margin-top: 4px;
  line-height: 1.3;
  opacity: 0.95;
  font-style: italic;
  text-align: center;
  max-width: 66px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-all;
}

/* 检验结果单元格：左按钮 + 右详情列表 */
.result-cell {
  display: flex;
  align-items: stretch;
  gap: 10px;
  justify-content: center;
}

.result-cell-left {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.result-cell-right {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  color: #606266;
  font-size: 12px;
  line-height: 1.4;
  padding: 6px 0;
  white-space: normal;
  word-break: break-all;
}

.result-detail-line {
  width: 100%;
}

/* 未选择状态 */
.result-none {
  background-color: #f56c6c;
  border: 1px dashed #909399;
}

.result-none .result-text {
  color: #909399;
}

/* 不符合 - 灰色 */
.result-gray {
  background-color: #909399;
}

/* 合格无附表 - 绿色 */
.result-green {
  background-color: #67c23a;
}

/* 合格有附表 - 黄色 */
.result-yellow {
  background-color: #e6a23c;
}

/* 无此项 - 蓝色 */
.result-blue {
  background-color: #409eff;
}

/* 表格行高增加 */
.page-one-layout ::v-deep .el-table__row {
  height: 80px !important; /* 原来大约40px，现在增加到80px */
}

.page-one-layout ::v-deep .el-table__row.row-level-1,
.page-one-layout ::v-deep .el-table__row.row-level-2 {
  height: 30px !important;
}

.page-one-layout ::v-deep .el-table__row.row-level-1 td,
.page-one-layout ::v-deep .el-table__row.row-level-2 td {
  padding: 0 !important;
}

.page-one-layout ::v-deep .el-table__row td {
  padding: 5px 0 !important; /* 增加上下padding */
}

.page-one-layout ::v-deep .el-table__row.group-start-row td {
  border-top: 4px solid #409eff !important;
}

.page-one-layout ::v-deep .el-table__row.group-end-row td {
  border-bottom: 4px solid #409eff !important;
}

.page-one-layout ::v-deep .el-table__row.level-3-group-start-row td {
  border-top: 2px solid #409eff !important;
}

.page-one-layout ::v-deep .el-table__row.level-3-group-end-row td {
  border-bottom: 2px solid #409eff !important;
}

.page-one-layout ::v-deep .el-table__row .cell {
  line-height: 1.5 !important;
  display: flex;
  align-items: center;
  justify-content: left;
  min-height: 60px;
  color: inherit;
}

.page-one-layout ::v-deep .el-table__row.row-level-1 .cell,
.page-one-layout ::v-deep .el-table__row.row-level-2 .cell {
  min-height: 30px !important;
}

/* 检验结果编辑弹窗样式 */
.result-dialog-content {
  padding: 20px 10px;
}

.result-item-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.info-label {
  font-weight: bold;
  color: #606266;
  margin-bottom: 8px;
}

.info-value {
  color: #303133;
  line-height: 1.6;
}

.result-selection {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.selection-label {
  font-weight: bold;
  color: #606266;
  margin-bottom: 12px;
}

.attachment-section {
  padding: 15px;
  background-color: #ecf5ff;
  border-radius: 4px;
  border-left: 4px solid #409eff;
}

.attachment-label {
  font-weight: bold;
  color: #606266;
  margin-bottom: 10px;
}

/* 详情列表样式 */
.detail-list-section .detail-item ::v-deep .el-checkbox__label {
  display: none !important;
}

.detail-list-section .detail-item .el-checkbox {
  margin-right: 10px;
}

/* 附表弹窗样式 */
.attachment-dialog-content {
  max-height: 75vh;
  overflow-y: auto;
}

.no-attachment {
  text-align: center;
  padding: 40px;
  color: #909399;
}
</style>
